export default {
  translations: {
    'Try it out': 'Experimentar',
    'Preview not available': 'Pré-visualização indisponível',
    'New Board': 'Nova Prancha',
    'Import from .zip': 'Importar .zip',
    'Importing...': 'Importando...',
    'Failed to import board.': 'Falha ao importar a prancha.',
    'Create board on the tablet?': 'Criar prancha no tablet?',
    'Import board to the tablet?': 'Importar prancha para o tablet?',
    "This board will be created in this user's tablet backup, not in your Portal boards. It will be sent to the tablet on the next sync.":
      'Esta prancha será criada no backup do tablet deste usuário, e não nas suas pranchas do Portal. Ela será enviada ao tablet na próxima sincronização.',
    'Board title': 'Título da prancha',
    'Enter a title for the board': 'Digite um título para a prancha',
    'Card language': 'Idioma do cartão',
    'Creating...': 'Criando...',
    'Failed to create board.': 'Falha ao criar a prancha.',
    'Choose an image from the bank, generate one with AI or upload your own.':
      'Escolha uma imagem do banco, gere uma com IA ou envie a sua.',
    'Used for the symbol bank and speech (text-to-speech) of this board.':
      'Usado para o banco de símbolos e a fala (texto para voz) desta prancha.',
    'How do you want to start?': 'Como você quer começar?',
    'Blank board': 'Começar em branco',
    'Start with tutorial': 'Ver tutorial',
    'Create a board from scratch': 'Crie uma prancha do zero',
    'Learn the studio with a ready-made board':
      'Aprenda o studio com uma prancha pronta',
    'Is this your first time creating boards?':
      'É sua primeira vez criando pranchas?',
    "Don't show this again": 'Não mostrar novamente',
    'Choose a title for your board': 'Escolha um título para sua prancha',
    'Preview board': 'Pré-visualização da prancha',
    'Displayed text': 'Texto exibido',
    'Back and edit': 'Voltar e editar',
    SMALL: 'Pequeno',
    MEDIUM: 'Médio',
    LARGE: 'Grande',
    login: {
      welcome: 'Bem vindo ao Livox!',
      error:
        'Não é possível logar com os dados informados. E-mail e/ou senha incorreto(s).',
      inactive_customer:
        'Sua conta foi desativada. Entre em contato com o suporte para obter assistência.',
    },
    payment: {
      purchaseFor: 'Compra sendo realizada para',
      supportEmail: 'E-mail de contato',
      onlyPortugueseAvailable:
        'O pagamento está disponível apenas em português no momento.',
      youHaveActiveSubscriptions: 'Você possui assinaturas ativas.',
      viewMyAssessments: 'Veja em Minhas Avaliações',
    },
    pm: {
      cards: 'Cartões',
      manageYourPayment:
        'Gerencie suas informações de pagamento. Para ver os detalhes da sua assinatura mensal, vá para Assinaturas.',
      defaultPayment: 'Pagamento padrão',
      setAsDefault: 'Definir como padrão',
      addCard: 'Adicionar cartão',
      addBoleto: 'Adicionar boleto',
      creditCard: 'Cartão de Crédito',
      boleto: 'Boleto',
      add: 'Adicionar',
      boletos: 'Boletos',
    },
    paymentRegister: {
      title: 'Cadastre-se para comprar o Livox',
      orLoginWithAccount: 'Já tem uma conta?',
      loginToComplete: 'Faça login para concluir a compra',
      orRegisterNew: 'Ou cadastre-se para criar uma nova conta',
      email: 'E-mail',
      fullName: 'Nome completo',
      emailRequired: 'E-mail é obrigatório',
      fullNameRequired: 'Nome completo é obrigatório',
      enterFullName: 'Digite seu nome completo',
      codeInfo:
        'Você receberá um código de 6 dígitos por e-mail. O código é válido por 15 minutos.',
      sending: 'Enviando...',
      sendCode: 'Enviar código de ativação',
      codeSentTo: 'Código enviado para',
      activationCode: 'Código de ativação',
      resendCode: 'Reenviar código',
      continue: 'Continuar',
      validating: 'Validando...',
      codeValid: 'Código válido.',
      changeEmail: 'Alterar e-mail',
      password: 'Senha',
      confirmPassword: 'Confirmar senha',
      enterPassword: 'Digite sua senha',
      confirmYourPassword: 'Confirme sua senha',
      passwordRequired: 'Senha é obrigatória',
      confirmPasswordRequired: 'Por favor confirme sua senha',
      activating: 'Ativando...',
      activateAccount: 'Ativar conta',
      back: 'Voltar',
      accountExists: 'Conta já existe. Faça login para continuar.',
      codeSentSuccess:
        'Um código de ativação de 6 dígitos foi enviado para seu e-mail. Válido por 15 minutos.',
      newCodeSent: 'Um novo código foi enviado para seu e-mail',
      somethingWrong: 'Algo deu errado',
      resendFailed: 'Falha ao reenviar código',
      passwordsDontMatch: 'As senhas não coincidem',
      activationFailed: 'Falha na ativação',
      accountActivated: 'Conta ativada com sucesso!',
      codeExpired: 'Código de ativação expirado ou inválido. Solicite um novo.',
      invalidCode: 'Código de ativação inválido.',
      accountAlreadyActive: 'Conta já ativa. Faça login.',
      rateLimit: 'Aguarde um momento antes de solicitar um novo código.',
      passwordRequirements:
        'A senha deve conter pelo menos uma letra maiúscula, uma minúscula, um caractere especial, um número e ter no mínimo 8 caracteres',
      holderAlreadyRegistered:
        'Já existe um titular cadastrado com este e-mail. Faça login no portal.',
      holderAlreadyRegisteredTitle: 'Titular já cadastrado',
      holderAlreadyRegisteredMessage:
        'Já existe um titular cadastrado com este e-mail. Faça login no portal para acessar sua conta.',
      holderAlreadyRegisteredMessageWithEmail:
        'Já existe um titular cadastrado com este e-mail. O e-mail {{email}} já foi criado como titular. Faça login no portal para acessar sua conta.',
      tokenInvalidOrExpired: 'Seu token está inválido ou expirou',
      goToLogin: 'Ir para login',
    },
    Role: 'Perfil',
    Often: 'Frequentemente',
    Sometimes: 'Às vezes',
    Never: 'Nunca',
    Date: 'Data',
    CGQ: 'CGT',
    VIQ: 'VIS',
    AUQ: 'AUD',
    OLQ: 'CLO',
    BHQ: 'CMP',
    Overall: 'Geral',
    Actions: 'A\u00e7\u00f5es',
    'Holder Info': 'Informa\u00e7\u00e3o do Titular',
    Loading: 'Carregando',
    Profile: 'Perfil',
    Comments: 'Coment\u00e1rios',
    'View Branch': 'Ver Filial',
    'Add License to Branch': 'Adicionar licen\u00e7a \u00e0 filial',
    'Create Board': 'Criar prancha',
    'Review Publication': 'Rever publica\u00e7\u00e3o',
    Creator: 'Criador',
    'Board History': 'Hist\u00f3rico de pranchas',
    'Change Customers to Support Area':
      'Alterar clientes para \u00e1rea de suporte',
    'Change Users to Support Area':
      'Alterar usu\u00e1rios para \u00e1rea de suporte',
    'Change Licenses to Branch': 'Alterar licen\u00e7as para filial',
    'Tablet code': 'C\u00f3digo do tablet',
    Back: 'Voltar',
    'Livox Store': 'Loja Livox',
    Communication: 'Comunica\u00e7\u00e3o',
    Leisure: 'Lazer',
    Feelings: 'Sentimentos',
    Hospital: 'Hospital',
    Social: 'Social',
    'Daily Life': 'Vida Di\u00e1ria',
    Foods: 'Alimenta\u00e7\u00e3o',
    School: 'Escola',
    Education: 'Educa\u00e7\u00e3o',
    Literacy: 'Alfabetiza\u00e7\u00e3o',
    Grammar: 'Gram\u00e1tica',
    Geography: 'Geografia',
    Science: 'Ci\u00eancias',
    History: 'Hist\u00f3ria',
    Math: 'Matem\u00e1tica',
    Biology: 'Biologia',
    Fun: 'Divers\u00e3o',
    Stories: 'Hist\u00f3rias',
    Games: 'Jogos',
    Game: 'Jogos',
    Memory: 'Memória',
    'Questions and Answers': 'Perguntas e Respostas',
    'Popular Items': 'Itens populares',
    'See more': 'Ver mais',
    Code: 'C\u00f3digo',
    'Last Modified': '\u00daltima modifica\u00e7\u00e3o',
    'Upload from .zip': 'Upload de .zip',
    'My Boards': 'Minhas Pranchas',
    'My Portal Boards': 'Minhas Pranchas do Portal',
    'Welcome {{name}}, you have {{count}} licenses':
      'Bem-vindo(a) {{name}}, você tem {{count}} licenças',
    'Publish one of your boards to share it with the Livox community.':
      'Publique uma das suas pranchas para compartilhar com a comunidade Livox.',
    'Welcome {{name}}, you have {{count}} users':
      'Bem-vindo(a) {{name}}, você tem {{count}} usuários',
    'A-Z': 'A-Z',
    Size: 'Tamanho',
    Studio: 'Studio',
    Favorites: 'Favoritos',
    Keyboard: 'Teclado',
    Import: 'Importar',
    Assign: 'Atribuir',
    'Cover Art': 'Arte de capa',
    Title: 'T\u00edtulo',
    Description: 'Descri\u00e7\u00e3o',
    Categories: 'Categorias',
    Submitter: 'Remetente',
    'Published at': 'Publicado em',
    View: 'Visualizar',
    'Pending Approval': 'Pendente de aprova\u00e7\u00e3o',
    'Holders Search': 'Pesquisa de titulares',
    'Filter Status': 'Filtro de status',
    'Audit Licenses': 'Auditar licen\u00e7as',
    'No Device': 'Sem dispositivo',
    'Livox Version': 'Vers\u00e3o do Livox',
    'Android Version': 'Vers\u00e3o do Android',
    'Last Validation At': '\u00daltima valida\u00e7\u00e3o em',
    Manage: 'Gerenciar',
    Store: 'Loja',
    Books: 'Livros',
    'Sign up': 'Cadastre-se',
    Talk: 'Falar',
    Learn: 'Aprender',
    Admin: 'Admin',
    'Store Admin': 'Admin da Loja',
    'Discover new boards, games and stories':
      'Descubra novas pranchas, jogos e histórias',
    'Search in store': 'Buscar na loja',
    'Search boards, games, stories...': 'Buscar pranchas, jogos, histórias...',
    'Recommended content': 'Conteúdos recomendados',
    'Featured boards': 'Pranchas em destaque',
    'New content': 'Novos Conteúdos',
    'Featured creators': 'Criadores em destaque',
    'My content': 'Meus conteúdos',
    'Unable to load your content': 'Não foi possível carregar seus conteúdos',
    'Import board': 'Importar prancha',
    'Created by': 'Criado por',
    'Board tags': 'Tags da prancha',
    'No tags': 'Sem tags',
    'Report content': 'Reportar conteúdo',
    'Report reason': 'Motivo da denúncia',
    Report: 'Reportar',
    'Report sent': 'Denúncia enviada',
    'Failed to send report': 'Falha ao enviar denúncia',
    'Offensive content': 'Conteúdo ofensivo',
    'Inappropriate language': 'Linguagem imprópria',
    'Sexual or inappropriate content': 'Conteúdo sexual/inadequado',
    Violence: 'Violência',
    'Hate speech': 'Discurso de ódio',
    'Spam or advertising': 'Spam ou propaganda',
    'Copyright infringement': 'Violação de direitos autorais',
    'Duplicate content': 'Conteúdo duplicado',
    'Off-topic content': 'Conteúdo fora do tema',
    'Exposed personal data': 'Dados pessoais expostos',
    'Content deleted': 'Conteúdo excluído',
    'Failed to delete content': 'Falha ao excluir conteúdo',
    'Sending...': 'Enviando...',
    'Sort by': 'Ordenar por',
    Downloads: 'Downloads',
    'Livox Community': 'Comunidade Livox',
    'Total downloads': 'Total de Downloads',
    'Community content': 'conteúdos da comunidade',
    Follow: 'Seguir',
    Following: 'Seguindo',
    'View content': 'Ver conteúdo',
    Community: 'Comunidade',
    Logout: 'Sair',
    'No description': 'Sem descrição',
    'No Title': 'Sem título',
    'View profile': 'Ver perfil',
    'New Releases': 'Novos Lançamentos',
    'Top Rated': 'Melhores Avaliados',
    'See all': 'Ver tudo',
    'Browse by category': 'Navegar por categoria',
    'No content found': 'Nenhum conteúdo encontrado',
    'Try adjusting your filters': 'Tente ajustar seus filtros',
    'Go to slide': 'Ir para o slide',
    'Back to Store': 'Voltar para a Loja',
    'Loading board...': 'Carregando publicação...',
    'No description provided': 'Sem descrição',
    stars: 'estrelas',
    votes: 'votos',
    Rate: 'Avaliar',
    'Be the first to rate': 'Seja o primeiro a avaliar',
    New: 'Novo',
    'In progress': 'Em progresso',
    'Tablet preview': 'Prévia no tablet',
    'Tablet preview coming soon': 'Prévia no tablet em breve',
    Republish: 'Republicar',
    Filters: 'Filtros',
    Clear: 'Limpar',
    Speak: 'Falar',
    Previous: 'Anterior',
    'Previous page': 'Página anterior',
    'Next page': 'Próxima página',
    'Remove last': 'Apagar último',
    Fullscreen: 'Tela cheia',
    'Exit fullscreen': 'Sair da tela cheia',
    'Go to Portal': 'Ir ao Portal',
    'Sign in': 'Entrar',
    'Open menu': 'Abrir menu',
    'Close menu': 'Fechar menu',
    Menu: 'Menu',
    'Made with care for everyone': 'Feito com carinho para todos',
    'Publication not available': 'Esta publicação não está disponível',
    'All languages': 'Todos os idiomas',
    'Switch to dark mode': 'Mudar para modo escuro',
    'Switch to light mode': 'Mudar para modo claro',
    'Toggle theme': 'Alternar tema',
    'Sign in to download': 'Entre para baixar',
    'Sign in to rate': 'Entre para avaliar',
    'Author not found': 'Autor não encontrado',
    'Unnamed author': 'Autor sem nome',
    publication: 'publicação',
    publications: 'publicações',
    'Boards by this author': 'Pranchas deste autor',
    'Link copied to clipboard': 'Link copiado para a área de transferência',
    'Failed to share': 'Falha ao compartilhar',
    'Failed to download content': 'Falha ao baixar o conteúdo',
    'Thanks for your vote!': 'Obrigado pelo seu voto!',
    'Failed to send vote': 'Falha ao enviar voto',
    'Content promoted': 'Conteúdo promovido',
    'Page Size': 'Tamanho da p\u00e1gina',
    'Licenses Search': 'Pesquisar Licen\u00e7as',
    Licenses: 'Licen\u00e7as',
    'Stripe Information': 'Informa\u00E7\u00F5es do Stripe',
    'No information': 'Sem informa\u00E7\u00F5es',
    Canceled: 'Cancelado',
    past_due: 'Pagamento atrasado',
    active: 'Ativado',
    'Support Areas': '\u00c1reas de Suporte',
    Customers: 'Clientes',
    'Livox Users': 'Usu\u00e1rios Livox',
    'Distributor Totals': 'Estat\u00edsticas de distribuidor',
    'Portal Administration': 'Administra\u00e7\u00e3o do Portal',
    'My Devices': 'Meus Dispositivos',
    'My Livox Users': 'Meus Usu\u00e1rios Livox',
    'My Licenses': 'Minhas Licen\u00e7as',
    'My Authorized Users': 'Meus Usu\u00e1rios do Sistema',
    'New Customer': 'Novo Cliente',
    'Notify Customer': 'Notificar Cliente',
    'New Branch': 'Nova Filial',
    'New Portal User': 'Novo Usu\u00e1rio do Portal',
    'Install Key': 'Chave de instala\u00e7\u00e3o',
    'License Key': 'Chave de licen\u00e7a',
    'New License': 'Nova Licen\u00e7a',
    'New Registration Link': 'Criar link de ativa\u00e7\u00e3o',
    'All Livox users': 'Todos Usu\u00e1rios Livox',
    Home: 'In\u00edcio',
    Customer: 'Cliente',
    'My Branches': 'Minhas Filiais',
    Branches: 'Filiais',
    'Last Name': 'Sobrenome',
    Gender: 'Gênero',
    Age: 'Idade',
    Evaluations: 'Avalia\u00e7\u00e3o',
    'Last Evalution': 'Ultima Avalia\u00e7\u00e3o',
    License: 'Licen\u00e7as',
    Key: 'Chave',
    Status: 'Status',
    City: 'Cidade',
    State: 'Estado',
    Country: 'Pa\u00eds',
    Available: 'Dispon\u00edvel',
    Active: 'Ativado',
    Inactive: 'Inativo',
    Phone: 'Telefone',
    'First Name': 'Primeiro Nome',
    'Device Name': 'Nome do Dispositivo',
    Version: 'Vers\u00e3o',
    'Remove Device': 'Remover Dispositivo',
    User: 'Usu\u00e1rio',
    Contact: 'Contato',
    Diagnosis: 'Diagn\u00f3stico',
    Device: 'Dispositivo',
    'Delete User': 'Remover Usu\u00e1rio',
    'My Users': 'Usu\u00e1rio do Livox',
    Expire: 'Data de expira\u00e7\u00e3o',
    Support: 'Suporte',
    Dates: 'Datas',
    'Expiration Date': 'Data de Expiração',
    'Support Date': 'Data de Suporte',
    'Click to edit expiration date': 'Clique para editar a data de expiração',
    'Click to edit support date': 'Clique para editar a data de suporte',
    'Expiration date updated successfully':
      'Data de expiração atualizada com sucesso',
    'Support date updated successfully':
      'Data de suporte atualizada com sucesso',
    'Failed to update expire date': 'Falha ao atualizar data de expiração',
    'Failed to update support date': 'Falha ao atualizar data de suporte',
    'MAC Address': 'Endere\u00e7o MAC',
    'Device Version': 'Vers\u00e3o do dispositivo',
    Name: 'Nome',
    'Num. Licenses': 'Num. Licen\u00e7as',
    Activated: 'Ativado',
    Inactivated: 'Inativado',
    Email: 'E-mail',
    'My Auth Users': 'Meus Usu\u00e1rios do Portal',
    Holder: 'Titular',
    'Customer Licenses': 'Licen\u00e7as do Cliente',
    Type: 'Tipo',
    Distribution: 'Distribuidor',
    Language: 'Idioma',
    Reseller: 'Revendedor',
    Text: 'Texto',
    'Number of Devices': 'N\u00famero de dispositivos',
    'Lifetime License': 'Licen\u00e7a vital\u00edcia',
    Address: 'Endere\u00e7o',
    Zipcode: 'CEP',
    Neighborhood: 'Bairro',
    'Contact Email': 'Email de contato',
    'Confirm Contact Email': 'Confirmar o email de contato',
    'First name': 'Nome',
    'Last name': 'Sobrenome',
    Group: 'Grupo',
    Password: 'Senha',
    Male: 'Masculino',
    Female: 'Feminino',
    'My Portal Users': 'Meus Usu\u00e1rios do Portal',
    'Edit Profile': 'Editar Perfil',
    'Change Password': 'Alterar senha',
    Register: 'Registrar',
    'I forgot my password': 'Eu esqueci minha senha',
    Account: 'Conta',
    'No results': 'Sem resultados',
    'Customers Search': 'Pesquisa de clientes',
    Search: 'Pesquisar',
    'Search by name or email': 'Pesquisar por nome ou e-mail',
    'Tree view': 'Visualização em árvore',
    'Table view': 'Visualização em tabela',
    Download: 'Download',
    'Registration Link': 'Link de Registro',
    Page: 'P\u00e1gina',
    of: 'de',
    results: 'resultados',
    'View Branches': 'Ver Filiais',
    'View Users': 'Ver Usuários',
    Cancel: 'Cancelar',
    Create: 'Criar',
    'Branch Name': 'Nome de usu\u00e1rio',
    'Confirm Password': 'Confirmar senha',
    'Customer Branches': 'Filiais do Cliente',
    'My Evaluations': 'Minhas avalia\u00e7\u00f5es',
    'Livox User': 'Usu\u00e1rio do Livox',
    'Add Branch': 'Adicionar Filial',
    'Distributor Customers': 'Clientes do distribuidor',
    'New Support Area': 'Nova \u00e1rea de suporte',
    'Assign Users': 'Atribuir usu\u00e1rios',
    'Assign Customers': 'Atribuir clientes',
    Dashboard: 'Painel de controle',
    'Unique users by day': 'Usu\u00e1rios \u00fanicos por dia',
    'Users by language': 'Usu\u00e1rios por idioma',
    'Users by country': 'Usu\u00e1rios por pa\u00eds',
    Devices: 'Dispositivos',
    'Manage my devices': 'Gerenciar meus dispositivos',
    News: 'Novidades',
    'Read more': 'Leia mais',
    'Total Licenses': 'Total de Licen\u00e7as',
    'Paid Licenses': 'Licen\u00e7as Compradas',
    'Free Licenses': 'Licen\u00e7as Doadas',
    'Distributor Stats': 'Estat\u00edsticas do Distribuidor',
    Users: 'Usu\u00e1rios',
    Remove: 'Remover',
    Evaluate: 'Avaliar',
    'Cognitive Evaluation': 'Avalia\u00e7\u00e3o Cognitiva',
    'Recognizes images': 'Reconhece imagens',
    'Notion of cause and effect': 'No\u00e7\u00e3o de causa e efeito',
    'Has notion of body awareness':
      'Tem no\u00e7\u00e3o de consci\u00eancia corporal',
    'Has symbolic representation': 'Tem representa\u00e7\u00e3o simb\u00f3lica',
    'Makes choices': 'Faz escolhas',
    Literate: 'Alfabetizado',
    'Auditory Agnosia': 'Agnosia Auditiva',
    'Cow mooing': 'Vaca mugindo',
    'Chicken clucking': 'Galinha cacarejando',
    'Dog barking': 'Cachorro latindo',
    Doorbell: 'Campainha de porta',
    Sirens: 'Sirene',
    'Visual Agnosia': 'Agnosia Visual',
    Dog: 'Cachorro',
    Cat: 'Gato',
    Bird: 'P\u00e1ssaro',
    House: 'Casa',
    Banana: 'Banana',
    Grapes: 'Uva',
    Pineapple: 'Abacaxi',
    Watermelon: 'Melancia',
    Telephone: 'Telefone',
    Car: 'Carro',
    Shoe: 'Sapato',
    Ball: 'Bola',
    'Visual Oral Language': 'Linguagem Oral Visual',
    'Where is the ball?': 'Onde est\u00e1 a bola?',
    'Where is the doll?': 'Onde est\u00e1 a boneca?',
    'Are you at home?': 'Voc\u00ea est\u00e1 em casa?',
    'What is the name of your mother?': 'Qual o nome de sua m\u00e3e?',
    'What is your name?': 'Qual \u00e9 o seu nome?',
    'Does he/she know his/her birthday?':
      'Ele/ela conhece a data do seu anivers\u00e1rio?',
    'Does he/she know his/her name?': 'Ele/ela conhece o nome dele(a)?',
    'Does he/she orient to date/time?': 'Ele/ela se orienta com data/hora?',
    'Can he/she follow one step directions?':
      'Ele/ela consegue seguir instru\u00e7\u00f5es de um passo?',
    'Can he/she follow two step directions?':
      'Ele/ela consegue seguir instru\u00e7\u00f5es de dois passos?',
    'Behavior Evaluation': 'Avalia\u00e7\u00e3o de comportamento',
    'Does he/she bite?': 'Ele/ela morde?',
    'Does he/she hit his/her head on the wall?':
      'Ele/ela bate a cabe\u00e7a contra a parede?',
    'Does he/she understand feelings?': 'Ele/ela entende sentimentos?',
    'Does he/she sleep well?': 'Ele/ela dorme bem?',
    General: 'Geral',
    'Does he/she cry?': 'Ele/ela chora?',
    'Does he/she have temper tantrums?': 'Ele/ela se zanga facilmente ?',
    'Is he/she aggressive?': 'Ele/ela \u00e9 agressiva?',
    'Does he/she eat well?': 'Ele/ela come bem?',
    'Does he/she run from one place to another?':
      'Ele/ela corre de um lugar para outro?',
    'Does he/she focus in an activity?':
      'Ele/ela se concentra em uma atividade?',
    'Does he/she play with other children?':
      'Ele/ela brinca com outras crian\u00e7as?',
    'Does he/she have a hard time to sleep?':
      'Ele/ela tem dificuldade para dormir?',
    'Does he/she like to be alone?': 'Ele/ela gosta de ficar sozinha?',
    'Does he/she demonstrate joint attention?':
      'Ele/ela demonstra aten\u00e7\u00e3o conjunta?',
    'Does he/she scream?': 'Ele/ela grita?',
    'Is he/she hypersensitive to sensory stimuli?':
      'Ele/ela \u00e9 hipersens\u00edvel a est\u00edmulos sensoriais?',
    'Is he/she unaware to sensory stimuli?':
      'Ele/ela \u00e9 insens\u00edvel a est\u00edmulos sensoriais?',
    Holders: 'Titulares',
    Purcharse: 'Comprar',
    Edit: 'Editar',
    Delete: 'Deletar',
    'E-mail': 'E-mail',
    'Full Name': 'Nome completo',
    'Phone Number': 'Telefone',
    Save: 'Salvar',
    Undo: 'Desfazer',
    Publish: 'Publicar',
    'New Item': 'Novo item',
    Attributes: 'Atributos',
    'Display Text': 'Texto a ser mostrado',
    'Spoken Phrase': 'Texto a ser falado',
    'Expand image on click': 'Expandir imagem ao clicar',
    Colors: 'Cores',
    Pictures: 'Fotos',
    'Search a symbol': 'Buscar um s\u00edmbolo',
    'Field Changed': 'Campo alterado',
    'Old Value': 'Valor antigo',
    'New Value': 'Novo valor',
    'License History': 'Hist\u00f3rico de Licen\u00e7a',
    Branch: 'Filial',
    'Evaluation Date': 'Data da Avalia\u00e7\u00e3o',
    'Branch Licenses': 'Licen\u00e7as da Filial',
    'Add Licenses to Branch': 'Adicionar licen\u00e7as \u00e0 Filial',
    Confirm: 'Confirmar',
    Close: 'Fechar',
    'Livox version distribution':
      'Distribui\u00e7\u00e3o por vers\u00e3o do Livox',
    'Expires in': 'Expira em',
    'Support ends': 'Suporte termina em',
    available: 'dispon\u00edvel',
    'Android OS distribution':
      'Distribui\u00e7\u00e3o por Vers\u00e3o do Android',
    likes: 'curtidas',
    downloads: 'downloads',
    'Reviewed at': 'Revisado em',
    Comment: 'Comentar',
    Pending: 'Pendente',
    Approved: 'Aprovado',
    Archived: 'Arquivado',
    Accept: 'Aceitar',
    Reject: 'Rejeitar',
    Reason: 'Motivo',
    Rejected: 'Rejeitado',
    'Create License Registration Link':
      'Criar link de registro de licen\u00e7a',
    'Create separate install keys':
      'Criar chaves de instala\u00e7\u00e3o separadas',
    'Log Out': 'Sair',
    'Evaluate Livox User': 'Avaliar usu\u00e1rio do Livox',
    Billing: 'Pagamento',
    'Acquire Livox': 'Adquirir o Livox',
    'You are about to purchase the best alternative comunication app in the world!':
      'Voc\u00ea est\u00e1 prestes a adquirir o melhor software de comunica\u00e7\u00e3o alternativa do mundo!',
    '1. Select a Plan': '1. Selecione um plano',
    BASIC: 'BASIC',
    'Up to 3 users': 'At\u00e9 3 usu\u00e1rios',
    'Smart Scan': 'Varredura Inteligente',
    'IntelliTouch - Touch Correction':
      'IntelliTouch - Corre\u00e7\u00e3o do Toque',
    'Virtual keyboard': 'Teclado Virtual',
    'Stock Images (20,000 images)': 'Banco de imagens (+20.000 imagens)',
    'Creation of pedagogical content':
      'Cria\u00e7\u00e3o de conte\u00fado pedag\u00f3gico',
    'Voice, text and image customization':
      'Personaliza\u00e7\u00e3o de voz, texto e imagem',
    'Content transfer between tablets':
      'Transfer\u00eancia de conte\u00fado entre tablets',
    '/ month': 'por m\u00eas',
    'on a yearly plan': 'no plano anual',
    PLUS: 'PLUS',
    'Recommended for families': 'Recomendado para fam\u00edlias',
    'New Features Update': 'Atualiza\u00e7\u00e3o de novos recursos',
    'Trigger Control': 'Controle com Acionadores',
    'Livox control with the blink of an eye': 'Controle com o piscar dos olhos',
    'Artificially Intelligent Item Recommendations Based on Time and Location':
      'Intelig\u00eancia Artificial para recomenda\u00e7\u00e3o de cart\u00f5es com base na hora e localiza\u00e7\u00e3o',
    PRO: 'PRO',
    'Recommended for professionals!': 'Recomendado para profissionais!',
    'UNLIMITED Users': 'Usu\u00e1rios ILIMITADOS',
    'Complete assessment and content tool to track users progress with Livox (patients or students)':
      'Avalia\u00e7\u00e3o completa e ferramenta de conte\u00fado para monitorar o progresso dos usu\u00e1rios com o Livox (pacientes ou alunos)',
    '2. Select a payment plan': '2. Selecione o plano de pagamento',
    monthly: 'mensal',
    quarterly: 'trimestral',
    '% off': '% de desconto',
    yearly: 'anual',
    '3. Confirm the value': '3. Confirme o valor',
    'per month': 'por m\u00eas',
    'Proceed with the checkout': 'Continuar',
    'Select a Plan': 'Selecione o plano',
    Continue: 'Continuar',
    'Get Livox': 'Comprar o Livox',
    'Select a Plan - Livox Portal': 'Escolha um plano - Livox',
    '1. Confirm your Plan': '1. Confirm seu Plano',
    '1. Choose your billing period': '1. Escolha o período de cobrança',
    '2. Choose your plan': '2. Escolha seu plano',
    '1. Choose your plan': '1. Escolha seu plano',
    '3. Confirm your selection': '3. Confirme sua seleção',
    '2. Confirm your selection': '2. Confirme sua seleção',
    Plan: 'Plano',
    'Save more': 'Economize mais',
    'Billing period': 'Período de cobrança',
    'Secure checkout': 'Pagamento Seguro',
    'Your payment information is encrypted and secure.':
      'Suas informações de pagamento são criptografadas e seguras.',
    'Please wait for your profile to load, or refresh the page.':
      'Aguarde o carregamento do seu perfil ou atualize a página.',
    'Powered by Stripe': 'Processado por Stripe',
    '3. Confirm the plan': '3. Confirme o plano',
    Checkout: 'Confirma',
    'per year': 'por ano',
    Change: 'Trocar',
    'per quarter': 'por trimestre',
    'Cardholder Name': 'Nome do Titular do Cart\u00e3o',
    'Street address': 'Endere\u00e7o',
    'Apartment / Suite / Unit / Building':
      'Apartamento / Suite / Unidade / Edif\u00edcio',
    'Billing Address': 'Endere\u00e7o de pagamento',
    'Payment Info': 'Informa\u00e7\u00f5es de pagamento',
    'Credit or debit card': 'Cart\u00e3o de cr\u00E9dito ou d\u00E9bito',
    'Credit card info secured by':
      'Informa\u00e7\u00f5es do cart\u00e3o s\u00e3o protegidas pelo',
    Success: 'Sucesso',
    'Upload from .zip file here': 'Upload de arquivo .zip',
    'Published Title': 'Titulo da Publica\u00e7\u00e3o',
    'Publish Content': 'Publicar Conte\u00fado',
    'Cover Image': 'Imagem de capa',
    'Upload Image': 'Enviar Imagem',
    Buy: 'Comprar',
    Boards: 'Pranchas',
    'Thanks for purcharsing Livox': 'Obrigado por adquirir o Livox',
    'Thanks for purchasing Livox': 'Obrigado por adquirir o Livox',
    'Your payment has been processed successfully.':
      'Seu pagamento foi processado com sucesso.',
    'Payment successful': 'Pagamento realizado',
    'Purchase summary': 'Resumo da compra',
    'What happens next?': 'O que acontece agora?',
    'Need help?': 'Precisa de ajuda?',
    'Contact support': 'Contatar suporte',
    'We are processing your payment, a receipt will be sent to':
      'N\u00f3s estamos processando seu pagamento, um recibo ser\u00e1 enviado para',
    'with instructions on how activate Livox.':
      'com instru\u00e7\u00f5es de como ativar o Livox.',
    'If you have any question / issues': 'Qualquer d\u00favida / problemas',
    'contact our support.': 'contate nosso suporte.',
    Deleted: 'Deletado',
    'You have successfully submitted this board for reviewing, please wait up to 48 hours to be approved.':
      'Voc\u00ea enviou esta prancha com sucesso! Por favor aguarde at\u00e9 48 horas para ser aprovada.',
    'You have successfully registered, Please return to the tablet to proceed.':
      'Voc\u00ea se cadastrou com sucesso, por favor retorne ao tablet para continuar.',
    'Validation notEmpty on coverImage failed':
      'Por favor adicione uma imagem a sua publica\u00e7\u00e3o',
    'You are not logged in. Create your account to see more of this content':
      'Voc\u00ea n\u00e3o est\u00e1 logado. Crie sua conta para ver mais deste conte\u00fado.',
    'Buy Livox': 'Comprar o Livox',
    'Select your plan and payment method to get started.':
      'Selecione seu plano e método de pagamento para começar.',
    'payment.pageDescription':
      'Selecione seu plano e método de pagamento para concluir a compra.',
    'payment.propaganda':
      'Você está prestes a adquirir o melhor software de comunicação alternativa do mundo!',
    'payment.activeSubscriptionsCount': '{{count}} assinatura(s) ativa(s)',
    'payment.youHaveLicenses': 'Você possui licenças ativas.',
    'payment.viewLicensesHere': 'Veja suas licenças aqui',
    'payment.youHaveActiveSubscriptions': 'Você possui assinaturas ativas.',
    'payment.viewMyAssessments': 'Veja em Minhas Avaliações',
    'payment.viewMySubscriptions': 'Veja em Minhas Assinaturas',
    'payment.onlyPortugueseTitle': 'Pagamento indisponível',
    'payment.onlyPortugueseAvailable':
      'O pagamento está disponível apenas em português no momento.',
    'payment.blockedInBrazilTitle': 'Pagamento indisponível na sua região',
    'payment.blockedInBrazil':
      'O pagamento online não está disponível para acessos a partir do Brasil.',
    'payment.blockedContactTitle': 'Entre em contato:',
    'payment.blockedContactBrazil':
      'Brasil\n+55 81 97108 3009 (Telefone e Whatsapp)\ncontato@livox.com.br\nAvenida Fagundes Varela, 950, LJ 15, CXP 1776, Jardim Atlântico, Olinda-Pe, Brasil, CEP: 53140-080',
    'payment.blockedContactUS':
      'EUA\n+1 (407) 449-6391\ncarlos@livox.com.br\nGrand National Drive, suite 128, Orlando, FL',
    'payment.blockedContactJordan':
      'Jordânia\n00962796870058\nala.alramahi@gmail.com',
    'payment.noLicensesEncourage':
      'Você não possui licenças. Adquira agora para começar a usar o Livox!',
    'Your boleto has been generated. Please complete the payment within the due date.':
      'Seu boleto foi gerado. Por favor, complete o pagamento até a data de vencimento.',
    'Back to Home': 'Voltar ao Início',
    'Please enter a valid CPF or CNPJ':
      'Por favor, insira um CPF ou CNPJ válido',
    'An error occurred': 'Ocorreu um erro',
    'Payment failed': 'Pagamento falhou',
    'Please fill in all required fields':
      'Por favor, preencha todos os campos obrigatórios',
    Media: 'M\u00eddia',
    'Upload an image or video': 'Enviar uma imagem / v\u00eddeo',
    'No image': 'Sem Imagem',
    'Welcome to your boards page': 'Bem vindo a sua paginas de pranchas',
    'Assistive Tecnology': 'Tecnologia Assistiva',
    '1. Create': 'Criar',
    'To get started use the Livox Studio to create cards, upload images, music and videos':
      'Para come\u00e7ar, use o Livox Studio para criar cart\u00f5es, fazer upload de imagens, m\u00fasicas e v\u00eddeos',
    '2. Publish': 'Publicar',
    'Submit you content to be published in the store':
      'Envie seu conte\u00fado a ser publicado na loja',
    '3. Get feedback': '3. Receba Feedback',
    'Receive feedback and satisfaction on seeing your content being used all around the globe!':
      'Receba feedback e avalia\u00e7\u00e3o de satisfa\u00e7\u00e3o sabendo que suas pranchas est\u00e3o sendo utilizadas ao redor do mundo.',
    'Livox Portal': 'Portal Livox',
    'A content store made for you!':
      'Uma loja de conte\u00fados feita para voc\u00ea!',
    'The best portal of assistive technologies in the world!':
      'O melhor portal de tecnologias assistivas do mundo!',
    'Learn More': 'Saiba Mais',
    'Recent Items': 'Itens Recentes',
    by: 'por',
    'Untitled Content': 'Conte\u00fado sem t\u00edtulo',
    'Loading...': 'Carregando...',
    'Click here to add a title': 'Cliquei aqui para adicionar um t\u00edtulo',
    'Portuguese (BR)': 'Portugu\u00eas (Brasil)',
    English: 'Ingl\u00eas',
    Arabic: '\u00c1rabe',
    German: 'Alem\u00e3o',
    'No boards found': 'Nenhuma prancha encontrada',
    'Removing this device will make the user log out of the app. Are you sure you want to remove this device?':
      'Remover esse dispositivo ir\u00e1 deslogar o titular do aplicativo. Tem certeza que quer remover esse dispositivo?',
    'New User': 'Novo usu\u00e1rio',
    'Login as another user': 'Entrar como outro usu\u00e1rio',
    Technical: 'T\u00e9cnico',
    Pedagogical: 'Pedag\u00f3gico',
    Results: 'Resultados',
    'Top Rated Items': 'Melhores Avaliados',
    'Back to Livox Portal': 'Voltar para o Portal',
    'No Categories': 'Sem categoria',
    Author: 'Autor',
    'No votes yet': 'Nenhum voto ainda',
    'Rate this content': 'Avalie esse conte\u00fado',
    'You must be logged in to vote on this content!':
      'Voc\u00ea precisa estar logado para votar nessa prancha!',
    'Go to Livox Store': 'Ir \u00e1 loja do Livox',
    'Go to Play Store': 'Ir \u00e1 Play Store',
    'Sign Up': 'Inscrever-se',
    Login: 'Entrar',
    'Log In': 'Entrar',
    'License Availability': 'Distribui\u00e7\u00e3o de Licen\u00e7as',
    'My Profile': 'Meu perfil',
    'No description available': 'Sem descri\u00e7\u00e3o',
    Publications: 'Publica\u00e7\u00f5es',
    'User Profile': 'Perfil de usu\u00e1rio',
    'New user': 'Novo usu\u00e1rio',
    'Livox Users Growth': 'Crescimento de usu\u00e1rios no Livox',
    'Users Disability Distribution':
      'Distribui\u00e7\u00e3o de Usu\u00e1rios por Defici\u00eancia',
    'Users Disabilty Distribution':
      'Distribui\u00e7\u00e3o de usu\u00e1rios por defici\u00eancia',
    'Contact us': 'Fale conosco',
    'Support Type': 'Tipo de suporte',
    Subject: 'Assunto',
    Message: 'Mensagem',
    Send: 'Enviar',
    'License Distribution': 'Distribui\u00e7\u00e3o de licen\u00e7as',
    'Manage my licenses': 'Gerenciar minhas licen\u00e7as',
    'Show From': 'Mostrar de',
    'Only my branch': 'Minha Filial',
    'All Branches': 'Todas as Filiais',
    'Last Validation Date': '\u00daltima data de valida\u00e7\u00e3o',
    'Device ID': 'ID do dispositivo',
    'About you': 'Sobre voc\u00ea',
    'No publications yet': 'Nenhuma publica\u00e7\u00e3o ainda',
    'No description available.': 'Sem descri\u00e7\u00e3o dispon\u00edvel.',
    'Remove this livox user? ': 'Remover este usu\u00e1rio? ',
    'Users by city': 'Usu\u00e1rios por cidade',
    'Create new customer': 'Criar novo cliente',
    'Boards Search': 'Procurar pranchas',
    'Add a branch to': 'Adicionar uma filial \u00e1',
    'Edit Branch': 'Editar uma filial',
    'Edit Customer': 'Editar cliente',
    Update: 'Atualizar',
    'Delete Branch': 'Deletar filial',
    'Create Branch Administrator': 'Criar administrador da filial',
    'Deleting this branch will remove the users and all licenses from it. Are you sure you want to delete this branch?':
      'Deletar essa filial ir\u00e1 remover todos os usu\u00e1rios e licen\u00e7as dela. Desejar continuar?',
    'Deleting this branch will transfer all users and licenses from this branch and its child branches to the parent branch.':
      'Deletar essa filial ir\u00e1 transferir todos os usu\u00e1rios e licen\u00e7as dessa filial e de suas filhas para a filial pai.',
    'Deleting the root branch will remove users, licenses, Livox users and holders of this customer and all its branches.':
      'Deletar a filial raiz ir\u00e1 remover usu\u00e1rios, licen\u00e7as, Livox users e holders desse cliente e de todas as suas filiais.',
    'Are you sure you want to delete this branch?':
      'Tem certeza que deseja excluir esta filial?',
    'Are you sure you want to delete branch':
      'Tem certeza que deseja excluir a filial',
    'Delete all users of this customer and all its branches.':
      'Excluir todos os usu\u00e1rios deste cliente e de todas as suas filiais.',
    'Delete all licenses of this customer and all its branches.':
      'Excluir todas as licen\u00e7as deste cliente e de todas as suas filiais.',
    'Delete all Livox users of this customer and all its branches.':
      'Excluir todos os Livox users deste cliente e de todas as suas filiais.',
    'Delete all holders of this customer and all its branches.':
      'Excluir todos os holders deste cliente e de todas as suas filiais.',
    'Transfer all users from this branch and its child branches to the parent branch.':
      'Transferir todos os usu\u00e1rios desta filial e de suas filiais filhas para a filial pai.',
    'Transfer all licenses from this branch and its child branches to the parent branch.':
      'Transferir todas as licen\u00e7as desta filial e de suas filiais filhas para a filial pai.',
    'Remove this branch and its child branch structure.':
      'Remover esta filial e a estrutura de suas filiais filhas.',
    'Reset Password': 'Redefinir Senha',
    'years ago': 'anos atr\u00e1s',
    'months ago': 'meses atr\u00e1s',
    'days ago': 'dias atr\u00e1s',
    'hours ago': 'horas atr\u00e1s',
    'minutes ago': 'minutos atr\u00e1s',
    'seconds ago': 'segundos atr\u00e1s',
    'Livox app is outdated on this device':
      'O aplicativo do Livox est\u00e1 desatualizado neste dispositivo',
    'Sort By...': 'Ordenar...',
    'Device Android Id': 'ID do dispositivo',
    Saved: 'Salvo',
    'Saving...': 'Salvando...',
    'Error! Please refresh the page.':
      'Erro! Por favor atualizar a p\u00e1gina.',
    Review: 'Revisar',
    'Upload an audio or video': 'Enviar um audio ou v\u00eddeo',
    'All Languages': 'Todos os idiomas',
    Portuguese: 'Portugu\u00eas (Brasil)',
    "By clicking 'Publish' you are agreeing that you have read and accepted our":
      'Ao clicar em "Publicar" voce est\u00e1 concordando que leu e aceitou nossos',
    'terms of use': 'termos de uso',
    'Add a shortcut...': 'Adicionar um atalho...',
    ExampleShortcut:
      'Por exemplo: "O que voce quer comer?" para uma prancha de alimentos.',
    'Create voice commands to open this board on Livox app!':
      'Ative a Conversa\u00e7\u00e3o Natural do Livox falando uma de suas palavras-chave. Depois, voc\u00ea pode mostrar a prancha atual falando um dos atalhos abaixo',
    Shortcuts: 'Atalhos',
    'NEW!': 'NOVO!',
    NEW: 'NOVO',
    'Uploading...': 'Enviando...',
    'Processing files...': 'Processando arquivos... Aguarde a finalização.',
    'The file you uploaded is too large.':
      'O arquivo que voce enviou \u00e9 muito grande.',
    'Error: File too large': 'Erro: O arquivo é muito grande',
    'Error: Sorry we just encoutered an unexpected error, please try again':
      'Erro: Desculpe, encontramos um erro inesperado. Por favor tente novamente',
    'Error: The zip file appears to be corrupted or is not a Livox content':
      'Erro: O arquivo zip parece estar corrompido ou n\u00E3o \u00E9 um conte\u00FAdo Livox',
    'Are you sure you want to delete this content?':
      'Tem certeza de que deseja excluir este conte\u00FAdo?',
    'Error: Invalid content, please make sure that the file being uploaded is a .zip file':
      'Erro: Conte\u00FAdo inv\u00E1lido, certifique-se de que o arquivo que est\u00E1 sendo carregado \u00E9 um arquivo .zip',
    'Get Started': 'Come\u00e7ar',
    'Record a new shortcut via voice': 'Grave um novo atalho usando sua voz',
    'You have blocked this website of using the Microphone.':
      'Voce bloqueou esse site para usar o microfone',
    "Couldn't detect speech, please check your microphone settings.":
      'N\u00e3o foi poss\u00edvel detectar uma fala, por favor veja se seu microfone est\u00e1 conectado.',
    'Your browser is not compatible with the Speech Recognition API, but you can manually enter the shortcuts below':
      'Seu navegador n\u00e3o suporta a transcri\u00e7\u00e3o de audio, por\u00e9m voc\u00ea pode escrever os atalhos manualmente abaixo.',
    'Error while recording shorcut, please try again':
      'Erro ao gravar atalho, por favor tente novamente.',
    Features: 'Funcionalidades',
    'Voice Shortcuts': 'Atalhos de Voz',
    'Add shortcuts to this folder': 'Adicionar atalhos a esta prancha',
    shortcuts: 'atalhos',
    'You have pending reviews': 'Voc\u00ea tem revis\u00f5es pendentes',
    'No pending reviews': 'Sem revis\u00f5es pendentes',
    'Admin Portal': 'Administra\u00e7\u00e3o do Portal',
    'Log out': 'Sair',
    'Zip Overwrite': 'Sobrescrever com Zip',
    Share: 'Compartilhar',
    'Used Licenses': 'Licen\u00e7as Usadas',
    'Last Registered Activity': '\u00daltima Atividade Resgistrada',
    'Interactions by time of day': 'Intera\u00e7\u00f5es por hora do dia',
    'Avg. Interactions / User':
      'M\u00e9dia de Intera\u00e7\u00f5es / Usu\u00e1rio',
    Featured: 'Destaque',
    'Promoted Content': 'Conte\u00fado Promovido',
    'Rate this': 'Avalie isto',
    Promote: 'Promover',
    'Your rating': 'Sua avalia\u00e7\u00e3o',
    Play: 'Reproduzir',
    'Back to Edit': 'Voltar \u00e0 Edi\u00e7\u00e3o',
    Next: 'Pr\u00f3ximo',
    'Inside items': 'Itens internos',
    Regular: 'Regular',
    'Book Mode': 'Modo Livro',
    Fixed: 'Fixado',
    System: 'Sistema',
    Rows: 'Linhas',
    Collumns: 'Colunas',
    Display: 'Exibi\u00e7\u00e3o',
    'Page Mode': 'Modo de P\u00e1gina',
    'Text Size': 'Tamanho do Texto',
    Print: 'Imprimir',
    'This dashboard is made with aggregated data across all licenses':
      'Este painel \u00e9 feito com dados agregados em todas as licen\u00e7as',
    ' assigned to your user': ' atribu\u00eddos ao seu usu\u00e1rio',
    'view licenses': 'ver licen\u00e7as',
    'No Data': 'Sem dados',
    'Last 30 days': '\u00daltimos 30 dias',
    'Last 6 months': '\u00daltimos 6 meses',
    'Last year': '\u00daltimo ano',
    'Results for': 'Resultados para',
    'Full Screen': 'Tela Cheia',
    Cut: 'Cortar',
    Copy: 'Copiar',
    'Card actions': 'Ações do cartão',
    'Card cut — tap an empty slot to paste':
      'Cartão cortado — toque em um espaço vazio para colar',
    'Copied — tap an empty slot to paste':
      'Copiado — toque em um espaço vazio para colar',
    Shared: 'Compartilhado',
    'Copied to clipboard': 'Copiado para a área de transferência',
    'Share not available on this device':
      'Compartilhamento não disponível neste dispositivo',
    'Could not share': 'Não foi possível compartilhar',
    'Download started': 'Download iniciado',
    'Card removed': 'Cartão removido',
    'Cards removed': 'Cartões removidos',
    'Cards cut — tap an empty slot to paste':
      'Cartões cortados — toque em um espaço vazio para colar',
    'Added to bar': 'Adicionado à barra',
    'Removed from bar': 'Removido da barra',
    'Add to fixed bar': 'Adicionar à barra fixa',
    'Add Item': 'Adicionar Item',
    selected: 'selecionados',
    'Multi-select actions': 'Ações de múltipla seleção',
    'Cards cut — navigate and paste into empty slots':
      'Cartões cortados — navegue e cole nos espaços vazios',
    'No empty slots to paste into': 'Sem espaços vazios para colar',
    'Cards pasted': 'Cartões colados',
    'cards still to paste': 'cartões ainda para colar',
    'ready to paste': 'prontos para colar',
    'Paste actions': 'Ações de colar',
    'Cards grouped into folder': 'Cartões agrupados em uma pasta',
    'Select at least 2 cards to group':
      'Selecione ao menos 2 cartões para agrupar',
    'New folder': 'Nova pasta',
    Paste: 'Colar',
    'Paste Inside': 'Colar Dentro',
    Dark: 'Modo Escuro',
    Light: 'Modo Claro',
    'Card Properties': 'Propriedade dos Cart\u00f5es',
    'Export PDF': 'Exportar PDF',
    'Export as PDF': 'Exportar como PDF',
    'Export section layout': 'Layout',
    'Export section content': 'Conteúdo',
    'Standard layout (grid)': 'Layout padrão (grade)',
    'Single card (1×1 full page)': 'Cartão único (1×1 página inteira)',
    'Select card to export': 'Selecione o cartão para exportar',
    'Select a card': 'Selecione um cartão',
    'Current board (grid)': 'Prancha atual (grade)',
    'Fixed bar only': 'Apenas barra fixa',
    'Board + Fixed bar': 'Prancha + Barra Fixa',
    'Main Board': 'Prancha Principal',
    Part: 'Parte',
    'Cut here': 'Recorte aqui',
    'Exported on': 'Exportado em',
    'Fixed Bar': 'Barra Fixa',
    'Cut for continuous use': 'Recorte para uso cont\u00ednuo',
    'Audio / Video': '\u00c1udio / V\u00eddeo',
    'Add an audio or video': 'Adicionar um \u00e1udio ou v\u00eddeo',
    'Uploaded image': 'Imagem carregada',
    'On touching this board show this image, if none set it will skip the action':
      'Ao tocar nesta prancha, mostre esta imagem, se nenhuma for configurada ir\u00e1 pular a a\u00e7\u00e3o',
    'Search an image': 'Pesquise uma imagem',
    Suggestions: 'Sugest\u00f5es',
    Images: 'Imagens',
    Publication: 'Publica\u00e7\u00e3o',
    'Manage Boards': 'Gerenciar Pranchas',
    'Livox Web': 'Livox Web',
    'Settings - Display': 'Configura\u00e7\u00f5es - Exibi\u00e7\u00e3o',
    Start: 'Iniciar',
    Settings: 'Configura\u00e7\u00f5es',
    'Manage Users': 'Gerenciar Usu\u00e1rios',
    Voice: 'Voz',
    Controls: 'Controles',
    'Artificial Inteligence': 'Intelig\u00eancia Artificial',
    About: 'Sobre',
    Test: 'Teste',
    'Voice Language': 'Idioma da Voz',
    'Voice Actor': 'Voz Escolhida',
    'Voice speed': 'Velocidade da Voz',
    'Pitch Rate': 'Taxa do Tom da Voz',
    Preview: 'Visualizar',
    'Quick chat': 'Conversa r\u00e1pida',
    'Font Size': 'Tamanho da Fonte',
    'Paging Mode': 'Modo de Pagina\u00e7\u00e3o',
    'Touch correction': 'Corre\u00e7\u00e3o do toque',
    'Time to wait between touches': 'Tempo de esperar entre os toques',
    'Manually set time to prevent any further touches. Set zero seconds to disable.':
      'Defina manualmente o tempo de espera para evitar novos toques. Defina zero segundos para desativar.',
    'Natural Conversation': 'Conversa\u00e7\u00e3o Natural',
    'Trigger words': 'Palavras-chave',
    'Registered keywords that Livox will listen before issuing an action. Keywords are case insensitive.':
      'Palavras-chave registradas que o Livox ouvir\u00e1 antes de executar uma a\u00e7\u00e3o. Palavras-chave n\u00e3o diferenciam mai\u00fasculas de min\u00fasculas.',
    'No keywords created': 'Nenhuma palavra-chave criada',
    'Speak navigation arrows': 'Falar os cart\u00f5es de navega\u00e7\u00e3o',
    'Enable natural conversation': 'Habilitar a Conversa\u00e7\u00e3o Natural',
    'Remote voice commands that can show appropriate boards depending on context. Requires a microphone and internet conection.':
      'Comandos de voz que podem exibir pranchas apropriadas dependendo do contexto. Requer um microfone e conex\u00e3o \u00e0 Internet.',
    'Enable Intellitouch': 'Habilitar Intellitouch',
    'Recommended for users with motor disabilities. Automatically detects impefect touches.':
      'Recomendado para usu\u00e1rios com defici\u00eancia motora. Detecta automaticamente toques imperfeitos.',
    'Delay will be set dynamically by Intellitouch.':
      'O tempo entre os toques ser\u00e1 definido dinamicamente pelo Intellitouch.',
    Legacy: 'Legado',
    'Livox5+': 'Livox 5.0+',
    'Licenses Status': 'Status das licen\u00e7as',
    'Activity days': 'Atividade',
    'Active Usage Status': 'Status de Uso Ativo',
    'Above Average': 'Acima da M\u00e9dia',
    'Below Average': 'Abaixo da M\u00e9dia',
    'Average Interactions':
      'M\u00e9dia de Intera\u00e7\u00f5es: {{clicks}} cliques.',
    'Inactive licenses are those in which no user has used Livox in the given period.':
      'Licen\u00e7as inativas s\u00e3o aquelas em que nenhum usu\u00e1rio utilizou o Livox no per\u00edodo determinado.',
    'Version Status': 'Status de Vers\u00e3o',
    'Devices with older Operating System (OS) versions are at risk of losing access to Livox.':
      'Dispositivos com vers\u00f5es mais antigas do Sistema Operacional (S.O.) correm o risco de perder o acesso ao Livox.',
    'Outdated OS': 'S.O. Desatualizado',
    'Outdated Livox': 'Livox Desatualizado',
    'Operational System Version': 'Vers\u00e3o do Sistema Operacional',
    'Device usage (%)': 'Uso do dispositivo (%)',
    'Device usage': 'Uso do dispositivo',
    'Disability distribution': 'Distribuição por deficiência',
    Period: 'Período',
    '30 days': '30 dias',
    '45 days': '45 dias',
    '2 months': '2 meses',
    '6 months': '6 meses',
    '1 year': '1 ano',
    'Global Active Usage': 'Uso Ativo Global',
    'Percent of the users that used above and below global average ({{clicks}} clicks).':
      'Porcentagem dos usu\u00e1rios que utilizaram acima ou abaixo da m\u00e9dia global ({{clicks}} cliques).',
    'Most Active': 'Mais Ativo',
    'Least Active': 'Menos Ativo',
    'The users that used 30% above and below than your average (> {{upper_limit}} and < {{lower_limit}} respectively).':
      'Os usu\u00e1rios que usaram 30% acima e abaixo da sua m\u00e9dia (> {{upper_limit}} e <{{lower_limit}} respectivamente).',
    'Active users are those that had at least 1 interaction on the time period.':
      'Usu\u00e1rios Ativos s\u00e3o aqueles que tiveram pelo menos 1 intera\u00e7\u00e3o no per\u00edodo.',
    'Activity ({{days}} days)': 'Atividade',
    'Activity Summary': 'Resumo de Atividade',
    'Dashboard Charts': 'Gráficos do Painel de Controle',
    'Users per disability': 'Usu\u00e1rios por defici\u00eancia',
    'Users per age': 'Usu\u00e1rios por idade',
    Autism: 'Autismo',
    'Amyotrophic Lateral Sclerosis': 'Esclerose Lateral Amiotr\u00F3fica',
    'Cerebral Palsy': 'Paralisia Cerebral',
    'Person without disabilities': 'Pessoa sem defici\u00EAncia',
    'No physical disabilities, just unable to speak':
      'Sem defici\u00EAncia f\u00EDsica, apenas incapaz de falar',
    'Stroke Sequelae': 'Sequelas de AVC',
    'Down Syndrome': 'S\u00EDndrome de Down',
    'Brain Injury': 'Les\u00E3o Cerebral',
    'Another motor impairment': 'Outra defici\u00EAncia motora',
    'Another cognitive impairment': 'Outra defici\u00EAncia cognitiva',
    'Store Statistics': 'Estat\u00edsticas da Loja',
    Creators: 'Criadores',
    Published: 'Publicados',
    'Unique Downloads': 'Downloads \u00danicos',
    Items: 'Itens',
    'SymbolStyx usage': 'Uso do SymbolStix',
    'Uploaded Images': 'Imagens Carregadas',
    'Uploaded Audio/Video': '\u00c1udio/V\u00eddeo Carregado',
    'Multiple images': 'M\u00faltiplas Imagens',
    'Most used symbols': 'S\u00edmbolos mais usados',
    'Usage Status': 'Status de uso',
    Disclaimer: 'Aviso',
    'basic plan disclaimer':
      'A licença BASIC é uma versão mais simples do Livox, com <b>menos recursos</b> e <b>sem suporte técnico</b>. Normalmente adquirida por pais que conhecem o Livox bem e, por exemplo, desejam um segundo dispositivo com menos recursos para seus filhos usarem ao ar livre. <br/> Esta versão não é recomendada para quem está começando a usar o Livox, é recomendada para quem já tem uma versão PLUS e deseja a BASIC para um segundo dispositivo.',
    'Available Licenses': 'Licenças Disponíveis',
    'Unable to log in with provided credentials.':
      'Não é possível logar com os dados informados. E-mail e/ou senha incorreto(s).',
    'Renew Licenses': 'Renovar Licenças',
    Border: 'Borda',
    'It is not possible to access cards with more than one state':
      'Não é possível acessar cartão com mais de um estado',
    'New state': 'Novo estado',
    'Only text': 'Apenas texto',
    'Livox IntelliBar (Beta)': 'IntelliBar do Livox (Beta)',
    'Print navigation card': 'Imprimir cartões de navegação',
    'Board + IntelliBar': 'Prancha + IntelliBar',
    'AI Error': 'Erro:',
    'Create items using AI!': 'Crie itens usando Inteligência Artificial!',
    'Get cards recommendations for every situation!':
      'Receba recomendações de cartões!',
    'Examples:': 'Exemplos',
    'Breakfast items': 'Itens de café da manhã',
    'Teeth brushing steps': 'Passos para escovar os dentes',
    'Quiz option choices': 'Quiz de perguntas de multipla escolha',
    'and many more!': 'e muito mais!',
    'Cards suggestion with AI': 'Recomendaçoes de cartão por IA',
    '{{used}} of {{limit}} used': '{{used}} de {{limit}} usados',
    'Insufficient JandaIA coins': 'Saldo de JandaIA Coins insuficiente',
    'Type a topic': 'Digite um tema',
    'Add card': 'Adicionar cartão',
    'Card added to board': 'Cartão adicionado à prancha',
    'No empty slots available': 'Sem espaços vazios disponíveis',
    'Failed to add card': 'Falha ao adicionar o cartão',
    'Print all pages': 'Imprimir todas as páginas',
    "Are you sure you want to delete the card(s)? This can't be undone!":
      'Tem certeza de que deseja excluir o(s) cartão(ões)? Isso não pode ser desfeito!',
    'Edit Email': 'Editar Email',
    'Already exists an user with informed email':
      'Já existe um usuário cadastrado com o e-mail informado',
    'Default Payment': 'Pagamento padrão',
    'ending with': 'terminado em',
    'Expires at': 'Expira em',
    'Plan details': 'Detalhes dos planos',
    "Passwords don't match": 'As senhas não correspondem',
    'Password must contain at least one uppercase letter, one lowercase letter, one special character, one number, and have a minimum length of 8 characters':
      'A senha deve conter pelo menos uma letra maiúscula, uma letra minúscula, um caractere especial, um número e ter no mínimo 8 caracteres',
    'User Already exists': 'Usuário já existe',
    'An email will be sent to activate the account':
      'Um email será enviado para ativar a conta',
    'Expire month': 'Mês de expiração',
    'Expire year': 'Ano de expiração',
    'Select as default payment method':
      'Selecionar como forma de pagamento padrão',
    'Change Billing': 'Alterar dados do cartão',
    'Change card details': 'Alterar detalhes do cartão',
    activate_license: 'Ativar Licença',
    'Change Livox Plan': 'Alterar plano Livox',
    'Due next in': 'Vencimento em',
    'Cancel motive': 'Motivo do cancelamento',
    'Are you sure you want to cancel the plan?':
      'Tem certeza que deseja cancelar o plano?',
    Card: 'Cartão',
    'My subscriptions': 'Minhas assinaturas',
    Cards: 'Cartões',
    'Welcome to Livox': 'Bem-vindo ao Livox',
    'enter your e-mail address': 'digite seu endereço de e-mail',
    'enter your password': 'digite sua senha',
    'Password requirements': 'Requisitos de senha',
    'Must be at least 8 characters long': 'Deve ter pelo menos 8 caracteres',
    'Must include at least one uppercase letter':
      'Deve incluir pelo menos uma letra maiúscula',
    'Must include at least one lowercase letter':
      'Deve incluir pelo menos uma letra minúscula',
    'Must include at least one number': 'Deve incluir pelo menos um número',
    'Must include at least one special character':
      'Deve incluir pelo menos um caractere especial',
    'Old Password': 'Senha Antiga',
    'New Password': 'Nova Senha',
    'enter your old password': 'digite sua senha antiga',
    'enter your new password': 'digite sua nova senha',
    'confirm your new password': 'confirme sua nova senha',
    'Holder Information': 'Informações do Titular',
    Client: 'Cliente',
    'My Subscriptions': 'Minhas Assinaturas',
    'Payment Methods': 'Métodos de Pagamento',
    'Payment History': 'Histórico de Pagamentos',
    'Livox Cloud': 'Livox Cloud',
    'of 1TB used': 'de 1TB usados',
    'Portal Livox': 'Portal Livox',
    'CONGRATS!': 'PARABÉNS!',
    'Based on your stats you used your account':
      'Com base nas suas estatísticas, você usou sua conta',
    'more than last month!': 'mais que no mês passado!',
    'Regional Food': 'Comida Regional',
    Animals: 'Animais',
    'The Flash Game': 'O Jogo Rápido',
    'All users': 'Todos os usuários',
    'All period': 'Todo o período',
    'Last day': 'Último dia',
    'Last week': 'Última semana',
    'Last month': 'Último mês',
    '1 month': '1 mês',
    'User Stats': 'Estatísticas do Usuário',
    'Play Games': 'Uso de Jogos',
    'Play Duration': 'Duração de Uso',
    '(minutes)': '(minutos)',
    Recommendations: 'Recomendações',
    'Shared Content': 'Conteúdo Compartilhado',
    'Total number of minutes:': 'Número total de minutos:',
    'Yes or No': 'Sim ou Não',
    Fruits: 'Frutas',
    Food: 'Comida',
    'Monthly Usage': 'Uso Mensal',
    'Amount of Interactions': 'Quantidade de Interações',
    "Oops! It looks like you haven't shared any content yet.":
      'Oops! Parece que você ainda não compartilhou nenhum conteúdo.',
    'Edit Your Profile': 'Edite Seu Perfil',
    Appearance: 'Aparência',
    'Privacy Terms': 'Termos de Privacidade',
    'Service Terms': 'Termos de Serviço',
    'Password Settings': 'Configurações de Senha',
    'For up to 3 users who already know or follow up with Livox professionals.':
      'Para até 3 usuários que já conhecem ou fazem acompanhamento com profissionais do Livox.',
    '/MONTH': '/MÊS',
    'Payment Method': 'Método de Pagamento',
    IntelliTouch: 'IntelliTouch',
    'Image Dataset': 'Banco de Imagens',
    'Current Plan': 'Plano Atual',
    'Other Subscriptions': 'Outras Assinaturas',
    cancel: 'Cancelar',
    cpfOrCnpj: 'CPF ou CNPJ',
    processing: 'Processando...',
    tryAgainIn: 'Tente novamente em {{seconds}}s',
    'BASIC SUBSCRIPTION': 'ASSINATURA BÁSICA',
    'Basic Subscription': 'Assinatura Básica',
    'See as list': 'Ver como lista',
    'See as grid': 'Ver como grade',
    'HOW IT WORKS?': 'COMO FUNCIONA?',
    '.zip upload': 'upload .zip ',
    'create board': 'criar prancha',
    create: 'criar',
    upload: 'upload',
    feedback: 'feedback',
    'To get started, use Livox Studio to create cards, upload images, music and videos!':
      'Para começar, use o Livox Studio para criar cartões, fazer upload de imagens, músicas e vídeos!',
    'Submit you content to be published in the portal!':
      'Envie seu conteúdo para ser publicado no portal!',
    'Receive feedback and satisfaction ratings knowing your boards are being used around the world!':
      'Receba feedback e índices de satisfação sabendo que seus painéis estão sendo usados ​​em todo o mundo!',
    Price: 'Preço',
    OK: 'OK',
    PENDING: 'PENDENTE',
    DECLINED: 'RECUSADO',
    ChangeLivoxPlan: 'Alterar plano do Livox',
    'Active Plans': 'Planos ativos',
    'Canceled Plans': 'Planos cancelados',
    'Are you sure you want to cancel the plan':
      'Tem certeza que deseja cancelar o plano?',
    'Plan changed sucessfully': 'Plano alterado com sucesso',
    'Plan cancel sucessfully': 'Plano cancelado com sucesso',
    'Provide the reason for cancellation': 'Informe o motivo do cancelamento',
    CHANGE: 'ALTERAR',
    paid: 'pago',
    open: 'pendente',
    draft: 'rascunho',
    void: 'cancelado',
    declined: 'recusado',
    uncollectible: 'incobrável',
    Invoices: 'Faturas',
    'Wrong password.': 'Senha antiga incorreta.',
    "The two password fields didn't match.":
      'As duas novas senhas não estão iguais.',
    'Something went wrong.': 'Algo deu errado.',
    'Please fill in all required fields.':
      'Preencha todos os campos obrigatórios.',
    'Password changed successfully!': 'Senha alterada com sucesso!',
    'Device Nickname': 'Apelido do Dispositivo',
    'License Information': 'Informações da Licença',
    to: 'de',
    'Licenses per page': 'Licenças por página',
    'Choose a payment method': 'Escolha um método de pagamento',
    'Published Content': 'Conteúdo Publicado',
    'View published content in the store': 'Ver conteúdos publicados na loja',
    'Payment Method changed sucessfully':
      'Método de pagamento atualizado com sucesso',
    'Device removed successfully': 'Dispositivo removido com sucesso',
    'Failed to remove device': 'Falha ao remover dispositivo',
    Monday: 'Segunda',
    Tuesday: 'Terça',
    Wednesday: 'Quarta',
    Thursday: 'Quinta',
    Friday: 'Sexta',
    Saturday: 'Sábado',
    Sunday: 'Domingo',
    'Evolution of use': 'Evolução de uso',
    'Use by schedule': 'Uso por horários do dia',
    '(clicks)': '(cliques)',
    Responsible: 'Responsável',
    Birthday: 'Data de Nascimento',
    Birthdate: 'Data de Nascimento',
    None: 'Nenhum',
    Mild: 'Leve',
    Moderate: 'Moderado',
    'Severe (Blindness)': 'Severo (Cegueira)',
    Good: 'Bom',
    'Severe (Needs switch)': 'Grave (Precisa de acionador)',
    'Few physical limitations': 'Poucas limitações físicas',
    'Dificulties in daily activities, requires assistance':
      'Dificuldades em atividades diárias, requer assistência',
    'Almost or totally dependent': 'Quase ou totalmente dependente',
    'Without communicative intent': 'Sem intenção comunicativa',
    'Does not verbalize, but has communicative intention':
      'Não verbaliza, mas tem intenção comunicativa',
    'Make ounds': 'Faz sons',
    'Makes vowel unions': 'Faz união de vogais',
    'Speak with very limited vocabulary (5-10 words)':
      'Fala com vocabulário muito limitado (5-10 palavras)',
    'Speak with limited vocabulary (10-30 words)':
      'Fala com vocabulário limitado (10-30 palavras)',
    'Fully communicative': 'Totalmente comunicativo',
    'Diagnosis Information': 'Informações do Diagnóstico',
    'Fine motor skills': 'Habilidades motoras finas',
    'Repetitive movements': 'Movimentos repetitivos',
    'Hearing impairment': 'Deficiência auditiva',
    'Visual impairment': 'Deficiência visual',
    'Current communication': 'Comunicação atual',
    'Autonomy level': 'Nível de autonomia',
    Have: 'Possui',
    'Does not have': 'Não possui',
    Yes: 'Sim',
    No: 'Não',
    'Customer Admin': 'Administrador do Cliente',
    'Portal Admin': 'Administrador do Portal',
    'Users per page': 'Usuários por página',
    Private: 'Privado',
    Organization: 'Organização',
    'License Usage': 'Utilização de Licenças',
    'Livox Usage': 'Uso do Livox',
    Amount: 'Quantidade',
    Used: 'Utilizado',
    'Users Status': 'Status dos usuários',
    'active users': 'usuários ativos',
    Disability: 'Deficiência',
    'Portal Users': 'Usuários do Portal',
    'Last Validation': 'Última Validação',
    Subscriptions: 'Assinaturas',
    'Public?': 'Público?',
    'Avaiable?': 'Disponível?',
    'Searching for boards from all your users':
      'Procurando por pranchas de todos os seus usuários',
    'Your filters did not find results':
      'Seus filtros não encontraram resultados',
    'not found': 'não encontrado',
    "It looks like your users haven't created boards yet":
      'Parece que seus usuários ainda não criaram pranchas',
    'no boards': 'sem pranchas',
    'Searching for your boards': 'Procurando por suas pranchas',
    'Find boards created by users in your organization here':
      'Encontre aqui as pranchas criadas pelos usuários da sua organização',
    'Removing this devices will make the user log out of the app. Are you sure you want to remove {{count}} device?':
      'Remover esses dispositivos irá deslogar o titulares dos aplicativos. Tem certeza que quer remover esses {{count}} dispositivos?',
    'Removing this device will make the user log out of the app. Are you sure you want to remove this devices?':
      'Remover esse dispositivo irá deslogar o titular do aplicativo. Tem certeza que quer remover esse dispositivo?',
    '{{count}} devices removed successfully':
      '{{count}} dispositivos removidos com sucesso',
    '{{count}} devices failed to be removed':
      '{{count}} dipositivos falharam ao ser removidos',
    'Branch removed successfully': 'Filial removida com sucesso',
    'Failed to remove branch': 'Falha ao remover filial',
    'Branches moved successfully': 'Filiais movidas com sucesso',
    'Failed to move branches': 'Falha ao mover filiais',
    'Move branches to:': 'Mover filiais para:',
    'Some selected branches have sub-branches. All sub-branches will also be moved.':
      'Algumas filiais selecionadas possuem sub-filiais. Todas as sub-filiais também serão movidas.',
    'Parent Branch': 'Filial Pai',
    Root: 'Raiz',
    'Sub-branch of': 'Sub-filial de',
    'Branch created successfully!': 'Filial criada com sucesso!',
    'Email already registered': 'Email já registrado',
    'Branch updated successfully!': 'Filial atualizada com sucesso!',
    'Create Branch': 'Criar Filial',
    'Update Branch': 'Editar Filial',
    'Edit Publication': 'Editar Publicação',
    'My Assessments': 'Minhas Avaliações',
    'Assessments Details': 'Detalhes das Avaliações',
    Assessment: 'Avaliação',
    'Assessments per page': 'Avaliações por página',
    Finish: 'Finalizar',
    'General assessment': 'Avaliação geral',
    'Temporal assessment': 'Avaliação temporal',
    'Assessment average': 'Avaliação média',
    Cognitive: 'Cognitivo',
    Auditory: 'Auditivo',
    Visual: 'Visual',
    Oral: 'Oral',
    Behaviour: 'Comportamental',
    Geral: 'Geral',
    'Add comment': 'Adicionar comentário',
    'Enter your comment for this assessment':
      'Digite o comentário para essa avaliação',
    'Assessment added successfully!': 'Avaliação adicionada com sucesso!',
    'Failed to add assessments': 'Falha ao adicionar avaliação',
    'New assessment': 'Nova avaliação',
    'Customer Support': 'Suporte Cliente',
    Promoted: 'Promovido',
    Statistics: 'Estatísticas',
    Details: 'Detalhes',
    Refuse: 'Recusar',
    Approve: 'Aprovar',
    'Content Details': 'Detalhes do Conteúdo',
    'boards per page': 'pranchas por página',
    'Searching for pending content...': 'Procurando por conteúdo pendente...',
    'Searching for promoted content...': 'Procurando por conteúdo promovido...',
    'Searching for published content...':
      'Procurando por conteúdo publicado...',
    Created: 'Criado',
    Demote: 'Despromover',
    'Demote Publication': 'Despromover Publicação',
    'Do you want to demote this content?':
      'Você quer despromover esse conteúdo?',
    'Approve Publication': 'Aprovar Publicação',
    'Do you approve this publication?': 'Você quer aprovar essa publicação?',
    'Original language': 'Idioma original',
    'Translate into (optional)': 'Traduzir para (opcional)',
    'The board was written in this language, not the one it was submitted as — the existing content will be relabeled, not translated.':
      'A prancha foi escrita neste idioma, não naquele em que foi enviada — o idioma do conteúdo existente será corrigido, sem tradução.',
    'Reject Publication': 'Rejeitar Publicação',
    'Enter the comment for this rejection':
      'Digite o comentário para essa rejeição',
    'Remove Publication': 'Remover Publicação',
    'Download count': 'Quantidade de downloads',
    'Successfully promoted!': 'Promovido com sucesso!',
    'An error occurred while promoting.': 'Um erro ocorreu durante a promoção.',
    'Upload a banner to promote this board.':
      'Faça o upload de um banner para promover esta prancha.',
    'Successfully published board!': 'Prancha publicada com sucesso!',
    'Successfully updated board!!': 'Prancha atualizada com sucesso!!',
    'An error occurred while submitting.':
      'Um erro aconteceu durante a submissão.',
    'Increase the description to at least 10 characters.':
      'Aumente a descrição para pelo menos 10 caracteres.',
    'Publish board': 'Publicar prancha',
    'Board submitted for review!': 'Prancha enviada para revisão!',
    'Please upload a cover image.': 'Envie uma imagem de capa.',
    'The board will be reviewed by an administrator before it appears in the store.':
      'A prancha será revisada por um administrador antes de aparecer na loja.',
    'Enter description': 'Digite a descrição',
    'Enter title': 'Digite o título',
    'Enter subtitle': 'Digite subtítulo',
    Subtitle: 'Subtítulo',
    'Email successfully sent!!!': 'Email enviado com sucesso!!!',
    'Error sending email!': 'Erro ao enviar email!',
    'The content has been demoted!': 'O conteúdo foi despromovido!',
    'Failed to demote content!': 'Falha ao despromover conteúdo!',
    'Publication successfully approved!': 'Publicação aprovada com sucesso!',
    'Failed to approve!': 'Falha ao aprovar!',
    'Publication successfully rejected!': 'Publicação rejeitada com sucesso!',
    'Failed to reject!': 'Falha ao rejeitar!',
    Activity: 'Atividade',
    'License Activity': 'Atividade das Licenças',
    'Active Licenses': 'Licenças Ativas',
    'Inactive Licenses': 'Licenças Inativas',
    'User Activity': 'Atividade dos Usuários',
    'Removing this sponsor will revoke acess to the dashboard and clear all licenses assigned to them.':
      'Remover este patrocinador revogará o acesso ao painel e limpará todas as licenças atribuídas a ele.',
    'Are you sure you want to delete this sponsor?':
      'Tem certeza de que deseja excluir este patrocinador?',
    'The sponsor has been deleted!': 'O patrocinador foi excluído!',
    'Failed to remove sponsor!': 'Falha ao remover patrocinador!',
    'Sponsor created successfully!': 'Patrocinador criado com sucesso!',
    'Sponsor updated successfully!': 'Patrocinador atualizado com sucesso!',
    'Edit Sponsor': 'Editar Patrocinador',
    'Create Sponsor': 'Criar Patrocinador',
    'enter sponsor name...': 'digite o nome do patrocinador...',
    'enter email...': 'digite o e-mail...',
    'New Sponsor': 'Novo Patrocinador',
    Sponsors: 'Patrocinadores',
    'Projects Details': 'Detalhes dos Projetos',
    'Project Dashboard': 'Painel de Controle do Projeto',
    'Sponsors per page': 'Patrocinadores por página',
    'Assign Licenses': 'Atribuir Licenças',
    '{{count}} licenses successfully assigned':
      '{{count}} licenças atribuidas com sucesso',
    'Failed to assign licenses': 'Falha ao atribuir licenças',
    'Assign licenses to sponsor': 'Atribuir licenças ao patrocinador',
    'Sponsor Licenses': 'Licenças do Patrocinador',
    'Sponsored Projects': 'Projetos Patrocinados',
    'Remove Licenses': 'Remover Licenças',
    'Remove licenses from sponsor': 'Remover licenças do patrocinador',
    '{{count}} licenses successfully removed':
      '{{count}} licenças removidas com sucesso',
    'Failed to remove licenses': 'Falha ao remover licenças',
    'Create Portal User': 'Criar Usuário do Portal',
    'enter first name...': 'digite o primeiro nome...',
    'enter last name...': 'digite o sobrenome...',
    'enter a password...': 'digite uma senha...',
    'You do not have active plans': 'Você não possui planos ativos',
    'You do not have canceled plans': 'Você não possui planos cancelados',
    'searching for your payment methods':
      'procurando por seus métodos de pagamento',
    'You have no payment methods': 'Você não possui métodos de pagamento',
    failed: 'falhou',
    'Your token is invalid or has expired':
      'Seu token está inválido ou foi expirado',
    'Password does not meet the minimum security requirements':
      'A senha não atende aos requisitos mínimos de segurança.',
    'Passwords do not match.': 'As senhas não correspondem.',
    'Resetting...': 'Redefinindo...',
    'validating your token': 'validando seu token',
    'Password successfully changed!': 'Senha alterada com sucesso!',
    'Error changing password!': 'Erro ao alterar senha!',
    'enter branch name': 'digite o nome da filial',
    'enter branch address': 'digite o endereço da filial',
    'enter customer name': 'digite o nome do cliente',
    'enter customer address': 'digite o endereço do cliente',
    'enter city': 'digite a cidade',
    'enter zip code': 'digite o CEP',
    'enter state': 'digite o estado',
    'enter phone number': 'digite o telefone',
    'Unauthorized Access': 'Acesso não autorizado',
    'You do not have permission to view this page with your current role.':
      'Você não tem permissão para visualizar esta página com seu cargo atual.',
    'Page Not Found': 'Página não encontrada',
    'Sorry, the page you are looking for doesn’t exist.':
      'Desculpe, a página que você está procurando não existe.',
    'Este campo não pode ser em branco.': 'Este campo não pode ser em branco.',
    'no licenses': 'sem licenças',
    'You do not have any licenses available.':
      'Você não tem nenhuma licença disponível.',
    licenses: 'licenças',
    users: 'usuários',
    Quantity: 'Quantidade',
    Indicator: 'Indicador',
    Value: 'Valor',
    Category: 'Categoria',
    Aggregate: 'Agregar',
    'Customers per page': 'Clientes por página',
    'Holders per page': 'Titulares por página',
    'Searching for your licenses': 'Procurando suas licenças',
    'There are no promoted boards': 'Não existem pranchas promovidas',
    'There are no pending boards': 'Não existem pranchas pendentes',
    'No data was found for this chart.':
      'Não foram encontrado dados para esse gráfico',
    Sponsor: 'Patrocinador',
    'My Projects': 'Meus Projetos',
    'Invalid Date': 'Data Inválida',
    'Organization Details': 'Detalhes da Organização',
    'All Licenses': 'Todas as Licenças',
    'All License Types': 'Todos os Tipos de Licença',
    'Select Branch': 'Selecione uma Filial',
    'Unlink Licenses': 'Liberar Licenças',
    'Unlink License': 'Liberar Licença',
    'Licenses transferred with success!': 'Licenças transferidas com sucesso!',
    'Error in transfer!': 'Erro ao transferir!',
    'An unexpected error occurred!': 'Um erro inesperado aconteceu!',
    'Transfer licenses to:': 'Transferir licenças para:',
    'When deleting this user from the Portal, they will remain available on your Livox tablet. If you don’t want this user’s data to be sent back to the Portal, delete them from your tablet as well.':
      'Ao excluir este usuário no Portal, ele permanecerá disponível no seu tablet Livox. Se não desejar que os dados desse usuário sejam novamente enviados para o Portal, exclua-o também no seu tablet.',
    'The Livox User has been deleted!': 'O Usuário do Livox foi removido!',
    'Livox User updated successfully!':
      'Usuário do Livox atualizado com sucesso!',
    'Edit Livox User': 'Editar Usuário do Livox',
    'Failed to remove Livox User!': 'Falha ao remover Livox User!',
    'Delete Livox User': 'Remover Livox User',
    'Are you sure you want to delete this livox user?':
      'Você tem certeza que deseja deletar esse usuário?',
    'Activate with QRCode': 'Ativar com QRCode',
    'Enter a valid holder email': 'Digite um e-mail de Titular válido',
    'To activate this license, enter the email of an associated holder.':
      'Para ativar esta licença, informe o e-mail de um Titular associado.',
    'Holder Email': 'E-mail do Titular',
    'Invalid email or not associated with this license.':
      'E-mail inválido ou não associado a esta licença.',
    Validate: 'Validar',
    'Activate with QRCode in your Livox app':
      'Ative com QRCode no seu aplicativo do Livox',
    Distributor: 'Distribuidor',
    'Distributor Admin': 'Distribuidor',
    'Distributor Support': 'Suporte do Distribuidor',
    'Create Support Area': 'Criar Área de Suporte',
    'enter support area name...': 'digite o nome da área do suporte...',
    'Support area created successfully!': 'Área de Suporte criada com sucesso!',
    'Support area updated successfully!':
      'Área de Suporte atualizada com sucesso!',
    'Edit Support Area': 'Editar Área de Suporte',
    'Removing this support area will only unlink customers and users from this area.':
      'Remover essa área de suporte irá somente desvinclular os cliente e usuários dessa área.',
    'Are you sure you want to delete this support area?':
      'Tem certeza de que deseja excluir esta área de suporte?',
    'The support area has been deleted!': 'A área de suporte foi excluída!',
    'Failed to remove support area!': 'Falha ao remover a área de suporte!',
    'Support Area Users': 'Usuários da Área de Suporte',
    'Remove Users': 'Remover Usuários',
    'Remove users from support area': 'Remover usuários dessa área de suporte',
    'Failed to remove users': 'Falha ao remover usuários',
    'Select Users': 'Selecione os Usuários',
    '{{count}} users successfully removed':
      '{{count}} usuários removidos com sucesso',
    'Support Area Customers': 'Clientes da Área de Suporte',
    'Select Customers': 'Selecione os Clientes',
    'Customers added successfully!': 'Clientes adicionados com sucesso!',
    'Remove Customers': 'Remover Clientes',
    '{{count}} customers successfully removed':
      '{{count}} clientes removidos com sucesso',
    'Failed to remove customers': 'Falha ao remover clientes',
    'Remove customers from support area':
      'Remover clientes dessa área de suporte',
    Add: 'Adicionar',
    'Support Areas per page': 'Áreas de Suporte por página',
    'Created at': 'Criado em',
    'Confirm delete': 'Confirmar exclusão',
    'Android Versions': 'Versões Android',
    'Create Android Version': 'Criar Versão Android',
    'Edit Android Version': 'Editar Versão Android',
    'New Android Version': 'Nova Versão Android',
    'Android version created successfully!':
      'Versão Android criada com sucesso!',
    'Android version updated successfully!':
      'Versão Android atualizada com sucesso!',
    'The android version has been deleted!': 'A versão Android foi excluída!',
    'Failed to remove android version!': 'Falha ao remover versão Android!',
    'Are you sure you want to delete this android version?':
      'Tem certeza que deseja excluir esta versão Android?',
    'Android Versions per page': 'Versões Android por página',
    Resellers: 'Revendedores',
    'Create Reseller': 'Criar Revendedor',
    'Edit Reseller': 'Editar Revendedor',
    'New Reseller': 'Novo Revendedor',
    'enter reseller name...': 'digite o nome do revendedor...',
    'Reseller created successfully!': 'Revendedor criado com sucesso!',
    'Reseller updated successfully!': 'Revendedor atualizado com sucesso!',
    'The reseller has been deleted!': 'O revendedor foi excluído!',
    'Failed to remove reseller. Make sure there are no licenses linked to it before deleting.':
      'Falha ao remover o revendedor. Certifique-se de que não há licenças vinculadas a ele antes de excluir.',
    'Are you sure you want to delete this reseller?':
      'Tem certeza que deseja excluir este revendedor?',
    'Resellers per page': 'Revendedores por página',
    'Payment QR Code': 'QR Code de Pagamento',
    'Payment link for {{name}}': 'Link de pagamento para {{name}}',
    'Payment link': 'Link de pagamento',
    UUID: 'UUID',
    'User created successfully!': 'Usuário criado com sucesso!',
    Spanish: 'Espanhol',
    French: 'Francês',
    Italian: 'Italiano',
    'Billing user does not exist': 'Usuário de cobrança não existe',
    'Our website has been updated to improve your experience. To ensure proper functionality, we recommend clearing your browser cache. If you are using the Livox app version 5, please close and reopen the app to ensure proper connection to your account.':
      'Nosso site foi atualizado para melhorar sua experiência. Para garantir o funcionamento correto, recomendamos limpar o cache do seu navegador. Se você estiver utilizando a versão 5 do aplicativo Livox, feche e reabra o aplicativo para garantir a conexão adequada à sua conta.',
    'Website Update': 'Atualização do site',
    'Reload page': 'Recarregar página',
    "Don't show again": 'Não mostrar novamente',
    'enter email': 'digite o e-mail',
    'Customer created successfully!': 'Cliente criado com sucesso!',
    'Enter a valid email address': 'Digite um endereço de e-mail válido',
    'Only letters are allowed': 'Apenas letras são permitidas',
    'enter number of devices': 'digite o número de dispositivos',
    'enter text': 'digite o texto',
    'enter install key...': 'digite a chave de instalação...',
    'enter device name...': 'digite o nome do dispositivo...',
    'enter device nickname...': 'digite o apelido do dispositivo...',
    'enter device MAC address...': 'digite o endereço MAC do dispositivo...',
    'Device MAC Address': 'Endereço MAC do Dispositivo',
    'Licenses created successfully!': 'Licenças criadas com sucesso!',
    Payment: 'Pagamento',
    'Registration link generated successfully!':
      'Link de registro gerado com sucesso!',
    'Failed to generate registration link.': 'Falha ao gerar link de registro.',
    'Copy Link': 'Copiar Link',
    'Link copied to clipboard!': 'Link copiado para a área de transferência!',
    '{{diff}} year(s) ago': '{{diff}} ano(s) atrás',
    '{{diff}} month(s) ago': '{{diff}} mês(es) atrás',
    '{{diff}} day(s) ago': '{{diff}} dia(s) atrás',
    '{{diff}} hour(s) ago': '{{diff}} hora(s) atrás',
    '{{diff}} minute(s) ago': '{{diff}} minuto(s) atrás',
    'Holder registered successfully!': 'Titular cadastrado com sucesso!',
    'Register Holder': 'Cadastrar Titular',
    'enter address': 'digite o endereço',
    'confirm your password': 'confirme sua senha',
    'Passwords must match': 'As senhas devem corresponder',
    'Professional Type': 'Tipo Profissional',
    'Speech Therapist': 'Fonoaudiólogo',
    'Occupational Therapist': 'Terapeuta Ocupacional',
    Physiotherapist: 'Fisioterapeuta',
    Teacher: 'Professor',
    Pedagogue: 'Pedagogo',
    Psychopedagogue: 'Psicopedagogo',
    Other: 'Outro',
    'Error loading subscription details':
      'Erro ao carregar detalhes da assinatura',
    Activation: 'Ativação',
    Cancellation: 'Cancelamento',
    'Due Date': 'Data de Vencimento',
    'Payment Link': 'Link de Pagamento',
    Receipt: 'Recibo',
    'View Receipt': 'Ver Recibo',
    'Invoice Date': 'Data da Fatura',
    Paid: 'Pago',
    'Invoice Status': 'Status da Fatura',
    'Receipt Link': 'Link do Recibo',
    'Status updated successfully': 'Status atualizado com sucesso',
    'Failed to update license status': 'Falha ao atualizar status da licença',
    'Edit License': 'Editar Licença',
    'Are you sure you want to delete this license?':
      'Tem certeza que deseja excluir esta licença?',
    'Are you sure you want to delete license':
      'Tem certeza que deseja excluir a licença',
    'This will delete all licenses with install key: {{installKey}}':
      'Isso excluirá todas as licenças com a chave de instalação: {{installKey}}',
    'Permanently delete the license(s)':
      'Excluir permanentemente a(s) licença(s)',
    'License deleted successfully!': 'Licença excluída com sucesso!',
    'Failed to delete license!': 'Falha ao excluir licença!',
    'License updated successfully!': 'Licença atualizada com sucesso!',
    'Failed to update license!': 'Falha ao atualizar licença!',
    'No changes to save': 'Nenhuma alteração para salvar',
    'Are you sure you want to update all licenses?':
      'Tem certeza que deseja atualizar todas as licenças?',
    'This will update all licenses with install key':
      'Isso atualizará todas as licenças com a chave de instalação',
    'Update install key to': 'Atualizar chave de instalação para',
    'Update type to': 'Atualizar tipo para',
    'All licenses with this install key will be affected!':
      'Todas as licenças com esta chave de instalação serão afetadas!',
    'Click here': 'Clique aqui',
    Donation: 'Doação',
    Sale: 'Venda',
    Evaluation: 'Avaliação',
    Research: 'Pesquisa',
    'Old Version (BETA TEST)': 'Versão Antiga (TESTE BETA)',
    Developer: 'Desenvolvedor',
    Representative: 'Representante',
    'Resale Channel': 'Canal de Revenda',
    'Are you sure you want to unblock this customer?':
      'Tem certeza que deseja desbloquear este cliente?',
    'Are you sure you want to block this customer?':
      'Tem certeza que deseja bloquear este cliente?',
    Block: 'Bloquear',
    'Change Status': 'Alterar Status',
    'Are you sure you want to change the status?':
      'Tem certeza de que deseja alterar o status?',
    Select: 'Selecione',
    'Unit manager': 'Gestor da unidade',
    'type to search': 'digite para buscar',
    'Manager e-mail': 'E-mail do gestor',
    'Create user': 'Criar usuário',
    'Cancel user creation': 'Cancelar criação de usuário',
    'Select existing user': 'Selecionar usuário existente',
    'enter password': 'digite a senha',
    'confirm password': 'confirme a senha',
    'Select a manager or create a new user':
      'Selecione um gestor ou crie um novo usuário',
    'Email not found. Click Create user':
      'E-mail não encontrado. Clique em Criar usuário',
    'This email already exists. Select an existing user':
      'Este e-mail já existe. Selecione um usuário existente',
    'Customer email already registered.': 'E-mail do cliente já cadastrado.',
    'Email is required': 'E-mail é obrigatório',
    'Invalid value': 'Valor inválido',
    'This field is required': 'Este campo é obrigatório',
    'Password is required': 'Senha é obrigatória',
    'Confirm Exit': 'Confirmar Saída',
    'Are you sure you want to exit? Any unsaved changes will be lost.':
      'Tem certeza que deseja sair? Quaisquer alterações não salvas serão perdidas.',
    Export: 'Exportar',
    'Export Charts': 'Exportar Gráficos',
    'Export Charts to PDF': 'Exportar Gráficos para PDF',
    'Export Data': 'Exportar Dados',
    'Exporting...': 'Exportando...',
    'No data to export': 'Sem dados para exportar',
    'No charts found to export': 'Nenhum gráfico encontrado para exportar',
    'File exported successfully': 'Arquivo exportado com sucesso',
    'Charts exported successfully': 'Gráficos exportados com sucesso',
    'Export successful!': 'Exportação bem-sucedida!',
    'Export failed!': 'Falha na exportação!',
    'Error exporting file': 'Erro ao exportar arquivo',
    'Error exporting charts': 'Erro ao exportar gráficos',
    'Are you sure you want to delete this user?':
      'Tem certeza que deseja excluir este usuário?',
    'Are you sure you want to delete user':
      'Tem certeza que deseja excluir o usuário',
    'This action will:': 'Esta ação irá:',
    'Unlink all licenses from the user holder':
      'Desvincular todas as licenças do titular do usuário',
    'Delete the associated holder (if exists)':
      'Excluir o titular associado (se existir)',
    'Remove user from all groups': 'Remover usuário de todos os grupos',
    'Delete all Livox Users linked to this user':
      'Excluir todos os Usuários do Livox vinculados a este usuário',
    'Permanently delete the user account':
      'Excluir permanentemente a conta do usuário',
    'This action cannot be undone!': 'Esta ação não pode ser desfeita!',
    'User updated successfully!': 'Usuário atualizado com sucesso!',
    'User deleted successfully!': 'Usuário excluído com sucesso!',
    '{{count}} licenses unlinked.': '{{count}} licenças desvinculadas.',
    'Holder deleted.': 'Titular excluído.',
    'Failed to delete user!': 'Falha ao excluir usuário!',
    'Changing password for user': 'Alterando senha para o usuário',
    'enter new password...': 'digite a nova senha...',
    'confirm new password...': 'confirme a nova senha...',
    'Update Password': 'Atualizar Senha',
    'Password updated successfully!': 'Senha atualizada com sucesso!',
    'confirm your password...': 'confirme sua senha...',
    'Edit Portal User': 'Editar Usuário do Portal',
    'User Details': 'Detalhes do Usuário',
    'Personal Data': 'Dados Pessoais',
    'View Details': 'Ver Detalhes',
    'View Holder Details': 'Ver Detalhes do Titular',
    'View Boards': 'Ver Pranchas',
    'View Content Store': 'Ver Loja de Conteúdos',
    'Created boards': 'Pranchas criadas',
    Total: 'Total',
    'Published boards': 'Pranchas publicadas',
    'No holder linked': 'Nenhum titular vinculado',
    'No customer linked': 'Nenhum cliente vinculado',
    'User Boards': 'Pranchas do Usuário',
    'View boards created by this user':
      'Veja as pranchas criadas por este usuário',
    'Customer not found': 'Cliente não encontrado',
    'Loading boards': 'Carregando pranchas',
    "This user hasn't created any boards yet":
      'Este usuário ainda não criou pranchas',
    'Create Holder': 'Criar Titular',
    'Edit Holder': 'Editar Titular',
    'Holder created successfully!': 'Titular criado com sucesso!',
    'No user found for this email. Fill in the fields below to create a new holder user.':
      'Nenhum usuário encontrado para este e-mail. Preencha os campos abaixo para criar um novo usuário titular.',
    'Holder updated successfully!': 'Titular atualizado com sucesso!',
    'Holder deleted successfully!': 'Titular excluído com sucesso!',
    'Are you sure you want to delete this holder?':
      'Tem certeza que deseja excluir este titular?',
    'Are you sure you want to delete holder':
      'Tem certeza que deseja excluir o titular',
    'Release all licenses from this holder':
      'Liberar todas as licenças deste titular',
    'Permanently delete the holder': 'Excluir permanentemente o titular',
    '{{count}} licenses released.': '{{count}} licenças liberadas.',
    'Failed to delete holder!': 'Falha ao excluir titular!',
    'User is required': 'Usuário é obrigatório',
    'Country is required': 'País é obrigatório',
    'Zipcode is required': 'CEP é obrigatório',
    'Phone number is required': 'Número de telefone é obrigatório',
    'enter zipcode...': 'digite o CEP...',
    'enter address...': 'digite o endereço...',
    'enter city...': 'digite a cidade...',
    'enter state...': 'digite o estado...',
    'enter phone number...': 'digite o número de telefone...',
    'enter professional record...': 'digite o registro profissional...',
    'Professional Record': 'Registro Profissional',
    'Holder Details': 'Detalhes do Titular',
    'Professional Information': 'Informações Profissionais',
    'No licenses linked': 'Nenhuma licença vinculada',
    'Livox User Details': 'Detalhes do Usuário Livox',
    'Personal Information': 'Informações Pessoais',
    'Health Information': 'Informações de Saúde',
    'Contact Information': 'Informações de Contato',
    'Responsible Information': 'Informações do Responsável',
    'Responsible 1 Name': 'Nome do Responsável 1',
    'Responsible 1 Email': 'E-mail do Responsável 1',
    'Responsible 1 Phone': 'Telefone do Responsável 1',
    'Responsible 2 Name': 'Nome do Responsável 2',
    'Responsible 2 Email': 'E-mail do Responsável 2',
    'Responsible 2 Phone': 'Telefone do Responsável 2',
    'Autonomy Level': 'Nível de Autonomia',
    'Current Communication': 'Comunicação Atual',
    'Visual Impairment': 'Deficiência Visual',
    'Fine Motor Skills': 'Habilidades Motoras Finas',
    'Repetitive Movements': 'Movimentos Repetitivos',
    'Hearing Impairment': 'Deficiência Auditiva',
    'No data available': 'Nenhum dado disponível',
    Unauthorized: 'Não autorizado',
    'Board settings': 'Configurações da prancha',
    'Board name and cover': 'Nome e capa da prancha',
    'Board name': 'Nome da prancha',
    'Board cover image': 'Imagem de capa da prancha',
    'Board cover': 'Capa da prancha',
    'Click the image to change': 'Clique na imagem para alterar',
    'Error uploading image': 'Erro ao enviar imagem',
    'Error saving title': 'Erro ao salvar o nome',
    'Move cards': 'Mover cartões',
    'Select cards': 'Selecionar cartões',
    Redo: 'Refazer',
    Help: 'Ajuda',
    Layout: 'Layout',
    'Board background color': 'Cor de fundo da prancha',
    'Card settings': 'Configurações do cartão',
    'Fixed bar settings': 'Configurações da barra fixa',
    'Lock board horizontal': 'Bloquear a prancha na horizontal',
    'Auto navigation cards': 'Cartões de navegações automáticos',
    back: 'voltar',
    Columns: 'Colunas',
    'Select background color': 'Selecione a cor de fundo',
    'General card settings': 'Configurações gerais dos cartões',
    'Show text only': 'Mostrar apenas os textos',
    'Text position': 'Localização do texto',
    Bottom: 'Inferior',
    Top: 'Superior',
    'Show cards with levels as folders':
      'Exibir os cartões com níveis em formato de pasta',
    'High contrast cards': 'Cartões em alto contraste',
    'Black and white cards': 'Cartões em preto e branco',
    IntelliBar: 'IntelliBar',
    'Enable IntelliBar': 'Ativar a IntelliBar',
    'IntelliBar description':
      'Quando habilitado, o Livox exibirá uma barra na parte superior da tela, na qual o usuário poderá criar frases. Essa funcionalidade requer o download da prancha dos cartões de conversação, "IntelliBar", caso você ainda não tenha feito o download.',
    'IntelliBar screen size': 'Tamanho da IntelliBar na tela',
    'Speak card when adding to IntelliBar':
      'Falar o cartão ao adicioná-lo na IntelliBar',
    Disabled: 'Desabilitado',
    Enabled: 'Habilitado',
    'Partially enabled': 'Parcialmente habilitado',
    intelibar_speak_disabled_desc:
      'O Livox só falará ao tocar no botão de falar da IntelliBar.',
    intelibar_speak_partial_desc:
      'Livox falará o cartão clicado que for inserido na IntelliBar.',
    intelibar_speak_full_desc: 'Livox falará todos os cartões clicados.',
    'Speak card before adding': 'Falar o cartão antes de adicionar',
    'Speak card after adding': 'Falar o cartão após adicionar',
    'Show only card text in IntelliBar':
      'Colocar somente o texto do cartão na IntelliBar',
    'Enable fixed bar': 'Ativar barra fixa',
    'Fixed bar scroll up': 'Rolar barra fixa para cima',
    'Fixed bar scroll down': 'Rolar barra fixa para baixo',
    'Fixed bar scroll left': 'Rolar barra fixa para a esquerda',
    'Fixed bar scroll right': 'Rolar barra fixa para a direita',
    'Fixed bar limit reached': 'Limite da barra fixa atingido',
    Position: 'Localização',
    Side: 'Lateral',
    'Visible cards count': 'Quantidade de cartões visíveis',
    'Show as folder': 'Exibir em formato de pasta',
    'Select card bar color': 'Selecione a cor da barra dos cartões',
    'Create a Card': 'Criar um cartão',
    Image: 'Imagem',
    'Text/Spoken text': 'Texto / texto falado',
    'Color Background': 'Cor de fundo',
    'Add media': 'Adicionar mídia',
    States: 'Estados',
    'Image Bank': 'Banco de imagens',
    'Artificial Intelligence': 'Inteligência artificial',
    'Search image': 'Buscar imagem',
    'Starts with': 'Começa com',
    'Card title': 'Título do cartão',
    'Spoken Text': 'Texto falado',
    'Letters; Numbers': 'Letras; Números',
    'Text/Spoken Text': 'Texto / Texto falado',
    card_title_description: 'Esse texto será mostrado no cartão.',
    'Spoken text': 'Texto falado',
    spoken_text_description:
      'Esse texto será lido. Você pode escrever textos longos se quiser.',
    'Text font': 'Fonte do texto',
    'Text color': 'Cor do texto',
    'Background Color': 'Cor de fundo',
    'Background color card': 'Cor de fundo do cartão',
    'Card border color': 'Cor da borda do cartão',
    'Attach a media': 'Anexar mídia',
    'No media': 'Sem mídia',
    'Record an audio': 'Gravar um áudio',
    'Pick an audio': 'Escolher um áudio',
    'Pick a video': 'Escolher um vídeo',
    'Cards Properties': 'Propriedades do cartão',
    'Show just text': 'Mostrar apenas texto',
    show_just_text_desc:
      'Se ativado, o Livox não mostrará mais cartões com imagem',
    'Large size images': 'Imagens em tamanho grande',
    large_images_desc: 'Se ativado, os cartões aparecerão maiores',
    'Keep the card unchanged': 'Manter o cartão inalterado',
    keep_unchanged_desc:
      'Este cartão não sofrerá modificações em pranchas com valores definidos como padrão',
    'Display card in folder format': 'Exibir cartão em formato de pasta',
    'Card Title': 'Título do cartão',
    'Upload Card': 'Enviar cartão',
    'Board layout': 'Layout da prancha',
    'Maintain relative positioning': 'Manter posicionamento relativo',
    help_move: 'Ative para arrastar e reordenar os cartões na prancha.',
    help_select: 'Ative para selecionar múltiplos cartões de uma vez.',
    help_yesno: 'Ative para adicionar botões Sim/Não nos cartões.',
    help_undo_redo: 'Desfazer ou refazer alterações nas configurações.',
    help_play_mode:
      'Abre a prancha em tela cheia para usar de verdade: navegue pelos cartões e pastas, monte frases e ouça a fala.',
    help_export_pdf:
      'Exporta a prancha atual como um arquivo PDF para imprimir ou compartilhar.',
    help_ia:
      'Use inteligência artificial para sugerir cartões automaticamente.',
    Interests: 'Interesses',
    'Android ID': 'Android ID',
    'Advanced Filters': 'Filtros Avançados',
    'Apply Filters': 'Aplicar Filtros',
    'Clear All': 'Limpar Tudo',
    Order: 'Ordenar',
    Ascending: 'Ascendente',
    Descending: 'Descendente',
    From: 'De',
    To: 'Até',
    All: 'Todos',
    Information: 'Informações',
    Location: 'Localização',
    Keys: 'Chaves',
    'Date of Birth': 'Data de Nascimento',
    'Activated Licenses': 'Licenças Ativadas',
    'Inactivated Licenses': 'Licenças Inativadas',
    Options: 'Opções',
    Hide: 'Esconder',
    Show: 'Visualizar',
    'Enter sublevel': 'Entrar no subnível',
    'Create folder': 'Criar pasta',
    'Edit Card': 'Editar cartão',
    'Add state': 'Adicionar estado',
    'Cannot access cards with more than one state':
      'Não é possível acessar cartões com mais de um estado.',
    'Cards with sublevels cannot have multiple states':
      'Cartões com subníveis não podem ter múltiplos estados.',
    Untitled: 'Sem título',
    'No states yet. Add one below.': 'Sem estados ainda. Adicione um abaixo.',
    'Generate image': 'Gerar imagem',
    'Enter image prompt...': 'Digite um prompt de imagem...',
    'Image style': 'Estilo de imagem',
    'Download image': 'Baixar imagem',
    Contains: 'Contém',
    'Type to search symbols': 'Digite para buscar símbolos',
    'Save failed': 'Erro ao salvar',
    'Choose file from computer': 'Escolher arquivo do computador',
    Upload: 'Upload',
    'Upload failed': 'Falha no upload',
    'Select from image bank': 'Selecione do banco de imagens',
    'Generate with AI': 'Gere com IA',
    Generated: 'Gerada',
    'Upload an image from your device': 'Envie uma imagem do seu dispositivo',
    'Choose a symbol from the image bank':
      'Escolha um símbolo do banco de imagens',
    Selected: 'Selecionado',
    'Unsaved image selected': 'Imagem pendente de salvamento',
    'Upload image from computer': 'Enviar imagem do computador',
    'Select an image before saving the card.':
      'Selecione uma imagem antes de salvar o cartão.',
    'Book Settings': 'Configurações do livro',
    'Text size': 'Tamanho do texto',
    'Highlight spoken text': 'Destacar texto falado',
    Exit: 'Sair',
    'Start over': 'Começar do início',
    'To enable Book Mode, add cards to the board':
      'Para ativar o Modo Livro, adicione cartões à prancha',
    'Deactivate Book Mode to create sublevels':
      'Desative o Modo Livro para criar subníveis',
    'Continue from page {{page}}': 'Continuar da página {{page}}',
    'Open at page {{page}}': 'Abrir na página {{page}}',
    'To enable Book Mode, add child cards':
      'Para ativar o Modo Livro, adicione cartões filhos',
    'This book has no pages': 'Este livro não tem páginas',
  },
}
